(function () {
  'use strict';

  var API_BASE_URL = 'https://api.havjoy.com';
  var JOB_STATUS_API_BASE_URL = API_BASE_URL;
  var SHOPIFY_UPLOAD_API_BASE_URL = API_BASE_URL;
  var TEMPLATE_TIMEOUT_MS = 8000;
  var REQUEST_TIMEOUT_MS = 60000;
  var POLL_INTERVAL_MS = 2500;
  var POLL_TIMEOUT_MS = 10 * 60 * 1000;
  var FRAME_EPSILON_PX = 1;
  var CUSTOMER_IMAGE_MAX_INPUT_BYTES = 15 * 1024 * 1024;
  var CUSTOMER_IMAGE_MAX_DIMENSION = 1024;
  var CUSTOMER_IMAGE_JPEG_QUALITY = 0.85;
  var DEFAULT_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
  var MOCKUP_SET_STORAGE_KEY = 'havjoy_mockup_sets_v1';
  var MOCKUP_SET_MAX_ITEMS = 20;
  var MOCKUP_SET_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
  var RECENT_UPLOADS_STORAGE_KEY = 'havjoy_recent_uploads';
  var RECENT_UPLOADS_MAX_ITEMS = 20;
  var COMPOSITE_IMAGE_PROMISE_CACHE = {};
  var HEIC_CONVERTER_PROMISE = null;

  function saveRecentUploadedUrl(url, isPrimary) {
    if (typeof url !== 'string' || !url) return;
    try {
      var rows = JSON.parse(window.localStorage.getItem(RECENT_UPLOADS_STORAGE_KEY) || '[]');
      if (!Array.isArray(rows)) rows = [];
      rows = rows.filter(function (item) {
        return !isObject(item) || !Array.isArray(item.urls) || item.urls.indexOf(url) === -1;
      });
      rows.unshift({ urls: [url], savedAt: new Date().toISOString(), primary: isPrimary !== false });
      window.localStorage.setItem(RECENT_UPLOADS_STORAGE_KEY, JSON.stringify(rows.slice(0, RECENT_UPLOADS_MAX_ITEMS)));
      window.dispatchEvent(new CustomEvent('havjoy:recent-upload-updated', { detail: { url: url } }));
    } catch (error) {
      console.warn('[HavJoy] Could not save uploaded image URL', error);
    }
  }

  function readLatestUploadedUrl() {
    try {
      var rows = JSON.parse(window.localStorage.getItem(RECENT_UPLOADS_STORAGE_KEY) || '[]');
      if (!Array.isArray(rows)) return '';
      var fallback = '';
      for (var index = 0; index < rows.length; index += 1) {
        var item = rows[index];
        var urls = isObject(item) && Array.isArray(item.urls) ? item.urls : [];
        var url = urls.find(function (value) { return typeof value === 'string' && /^https?:\/\//i.test(value); }) || '';
        if (!url) continue;
        if (!fallback) fallback = url;
        if (item.primary !== false) return url;
      }
      return fallback;
    } catch (error) {
      return '';
    }
  }

  function isObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  function normalizeMockupVariantName(value) {
    return String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ');
  }

  function readStoredMockupSets() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(MOCKUP_SET_STORAGE_KEY) || '[]');
      var cutoff = Date.now() - MOCKUP_SET_MAX_AGE_MS;
      return Array.isArray(stored) ? stored.filter(function (item) {
        return isObject(item) && typeof item.id === 'string' && item.id &&
          Number(item.updatedAt) >= cutoff && isObject(item.variants) && Array.isArray(item.urls);
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function storeCompletedMockupSet(completed, template) {
    if (!completed || !template || typeof completed.artworkUrl !== 'string' || !completed.artworkUrl) return;
    var variants = {};
    var urls = [];
    template.mockups.forEach(function (mockup) {
      var url = completed.mockupUrls && completed.mockupUrls[mockup.key];
      var variantName = normalizeMockupVariantName(mockup.variantName);
      if (typeof url !== 'string' || !url || !variantName) return;
      variants[variantName] = url;
      if (urls.indexOf(url) === -1) urls.push(url);
    });
    if (!urls.length) return;
    try {
      var sets = readStoredMockupSets().filter(function (item) { return item.id !== completed.artworkUrl; });
      sets.unshift({
        id: completed.artworkUrl,
        updatedAt: Date.now(),
        variants: variants,
        urls: urls
      });
      window.localStorage.setItem(MOCKUP_SET_STORAGE_KEY, JSON.stringify(sets.slice(0, MOCKUP_SET_MAX_ITEMS)));
      window.dispatchEvent(new CustomEvent('havjoy:mockup-set-updated'));
    } catch (error) {
      console.warn('[HavJoy] Could not cache mockup variants for cart', error);
    }
  }

  function parseJsonElement(id) {
    var element = document.getElementById(id);
    if (!element) return null;
    try { return JSON.parse(element.textContent || '{}'); }
    catch (error) { return null; }
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, timeoutMs);
    return fetch(url, Object.assign({}, options || {}, { signal: controller.signal }))
      .finally(function () { window.clearTimeout(timer); });
  }

  function wait(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }

  function logGenerationTiming(label, sessionId, startedAt, status, progress) {
    var elapsedSeconds = ((performance.now() - startedAt) / 1000).toFixed(1);
    var progressText = Number.isFinite(Number(progress)) ? ' | progress ' + Number(progress) + '%' : '';
    console.info('[HavJoy] ' + label + ' | ' + sessionId + ' | ' + status + ' | ' + elapsedSeconds + 's' + progressText);
  }

  function applyTshirtVariousMockups(template, rawMockups, rawCanvas) {
    if (!template || !Array.isArray(template.mockups) || !Array.isArray(rawMockups) || !isObject(rawCanvas)) return false;
    var expectedKeys = Array.isArray(template.mockupKeys) ? template.mockupKeys : [];
    if (!expectedKeys.length) return false;
    var canvasWidth = Number(rawCanvas.width);
    var canvasHeight = Number(rawCanvas.height);
    if (!Number.isFinite(canvasWidth) || canvasWidth <= 0 || !Number.isFinite(canvasHeight) || canvasHeight <= 0) return false;
    var normalized = {};
    rawMockups.forEach(function (raw) {
      if (!isObject(raw) || expectedKeys.indexOf(raw.key) === -1 || normalized[raw.key]) return;
      var templateMockup = template.mockups.find(function (mockup) { return mockup.key === raw.key; });
      var templatePrintArea = templateMockup && templateMockup.templatePrintArea;
      if (!templatePrintArea || !templateMockup.templateUrl) return;
      var sourceWidth = Number(raw.width);
      var sourceHeight = Number(raw.height);
      var renderWidth = Number(raw.render_width);
      var renderHeight = Number(raw.render_height);
      var runtimeGarmentScale = raw.garment_scale == null ? null : Number(raw.garment_scale);
      var garmentScale = templateMockup.templateGarmentScale;
      if (
        !Number.isFinite(sourceWidth) || sourceWidth <= 0 || !Number.isFinite(sourceHeight) || sourceHeight <= 0 ||
        Math.abs(sourceWidth - templateMockup.templateWidth) > FRAME_EPSILON_PX ||
        Math.abs(sourceHeight - templateMockup.templateHeight) > FRAME_EPSILON_PX ||
        !Number.isFinite(renderWidth) || renderWidth !== canvasWidth || !Number.isFinite(renderHeight) || renderHeight !== canvasHeight ||
        !Number.isFinite(garmentScale) || garmentScale < 0.5 || garmentScale > 2.5
      ) return;
      if (runtimeGarmentScale !== null && (
        !Number.isFinite(runtimeGarmentScale) || Math.abs(runtimeGarmentScale - garmentScale) > 0.001
      )) return;
      var containScale = Math.min(renderWidth / sourceWidth, renderHeight / sourceHeight);
      var garmentWidth = sourceWidth * containScale * garmentScale;
      var garmentHeight = sourceHeight * containScale * garmentScale;
      var garmentX = (renderWidth - garmentWidth) / 2;
      var garmentY = (renderHeight - garmentHeight) / 2;
      var frameX = garmentX + sourceWidth * templatePrintArea.x * containScale * garmentScale;
      var frameY = garmentY + sourceHeight * templatePrintArea.y * containScale * garmentScale;
      var frameW = sourceWidth * templatePrintArea.w * containScale * garmentScale;
      var frameH = sourceHeight * templatePrintArea.h * containScale * garmentScale;
      if (
        ![frameX, frameY, frameW, frameH].every(Number.isFinite) ||
        frameX < -FRAME_EPSILON_PX || frameY < -FRAME_EPSILON_PX || frameW <= 0 || frameH <= 0 ||
        frameX + frameW > renderWidth + FRAME_EPSILON_PX || frameY + frameH > renderHeight + FRAME_EPSILON_PX
      ) return;
      normalized[raw.key] = {
        url: templateMockup.templateUrl,
        width: canvasWidth,
        height: canvasHeight,
        sourceWidth: sourceWidth,
        sourceHeight: sourceHeight,
        renderWidth: renderWidth,
        renderHeight: renderHeight,
        garmentScale: garmentScale,
        garmentRect: { x: garmentX, y: garmentY, w: garmentWidth, h: garmentHeight },
        framePx: { x: frameX, y: frameY, w: frameW, h: frameH },
        printArea: { x: templatePrintArea.x, y: templatePrintArea.y, w: templatePrintArea.w, h: templatePrintArea.h },
        clipPx: { x: frameX, y: frameY, w: frameW, h: frameH },
        fit: 'contain'
      };
    });
    if (expectedKeys.some(function (key) { return !normalized[key]; })) return false;
    if (expectedKeys.some(function (key) {
      return !template.mockups.some(function (mockup) { return mockup.key === key; });
    })) return false;
    template.mockups.forEach(function (mockup) {
      if (normalized[mockup.key]) mockup.overlay = normalized[mockup.key];
    });
    return true;
  }

  function loadCompositeImage(url) {
    if (COMPOSITE_IMAGE_PROMISE_CACHE[url]) return COMPOSITE_IMAGE_PROMISE_CACHE[url];
    var promise = new Promise(function (resolve, reject) {
      var image = new Image();
      var timer = window.setTimeout(function () {
        delete COMPOSITE_IMAGE_PROMISE_CACHE[url];
        reject(new Error('Composite image timed out'));
      }, 30000);
      image.crossOrigin = 'anonymous';
      image.onload = function () { window.clearTimeout(timer); resolve(image); };
      image.onerror = function () {
        window.clearTimeout(timer);
        delete COMPOSITE_IMAGE_PROMISE_CACHE[url];
        reject(new Error('Could not load composite image'));
      };
      image.src = url;
    });
    COMPOSITE_IMAGE_PROMISE_CACHE[url] = promise;
    return promise;
  }

  function preloadTemplateMockups(template) {
    if (!template || !Array.isArray(template.mockups)) return;
    template.mockups.forEach(function (mockup) {
      if (mockup.templateUrl) loadCompositeImage(mockup.templateUrl).catch(function () {});
    });
  }

  function canvasToJpeg(canvas) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (blob) resolve(blob);
        else reject(new Error('Could not export mockup image'));
      }, 'image/jpeg', 0.92);
    });
  }

  async function composeTshirtVariousMockup(mockup, artworkUrl) {
    if (!mockup || !mockup.overlay || !artworkUrl) throw new Error('Missing composite assets');
    var overlay = mockup.overlay;
    var proxiedArtworkUrl = API_BASE_URL + '/api/proxy-image?url=' + encodeURIComponent(artworkUrl);
    var images = await Promise.all([
      loadCompositeImage(overlay.url),
      loadCompositeImage(proxiedArtworkUrl)
    ]);
    var canvas = document.createElement('canvas');
    canvas.width = overlay.renderWidth;
    canvas.height = overlay.renderHeight;
    var context = canvas.getContext('2d');
    if (!context) throw new Error('Canvas is unavailable');

    context.fillStyle = '#fffcf3';
    context.fillRect(0, 0, canvas.width, canvas.height);
    var garmentRect = overlay.garmentRect;
    if (!garmentRect) throw new Error('Missing garment placement');
    context.drawImage(
      images[0],
      garmentRect.x,
      garmentRect.y,
      garmentRect.w,
      garmentRect.h
    );

    var frame = overlay.framePx;
    var artworkScale = Math.min(frame.w / images[1].naturalWidth, frame.h / images[1].naturalHeight);
    var artworkWidth = images[1].naturalWidth * artworkScale;
    var artworkHeight = images[1].naturalHeight * artworkScale;
    var clip = overlay.clipPx;
    context.save();
    if (clip) {
      context.beginPath();
      context.rect(clip.x, clip.y, clip.w, clip.h);
      context.clip();
    }
    context.drawImage(
      images[1],
      frame.x + (frame.w - artworkWidth) / 2,
      frame.y + (frame.h - artworkHeight) / 2,
      artworkWidth,
      artworkHeight
    );
    context.restore();
    return canvasToJpeg(canvas);
  }

  async function uploadTshirtVariousMockup(blob, key) {
    var requestedFilename = 'havjoy-' + key + '-' + Date.now() + '.jpg';
    var prepareResponse = await fetchWithTimeout(SHOPIFY_UPLOAD_API_BASE_URL + '/api/shopify-prepare-upload', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        filename: requestedFilename,
        mime_type: 'image/jpeg',
        file_size: blob.size
      })
    }, REQUEST_TIMEOUT_MS);
    var prepared = await prepareResponse.json().catch(function () { return {}; });
    if (
      !prepareResponse.ok || !isObject(prepared) || prepared.fallback === true ||
      typeof prepared.url !== 'string' || !prepared.url ||
      typeof prepared.resourceUrl !== 'string' || !prepared.resourceUrl ||
      !Array.isArray(prepared.parameters)
    ) {
      throw new Error('Could not prepare ' + key + ' mockup upload');
    }

    var stagedBody = new FormData();
    prepared.parameters.forEach(function (parameter) {
      if (isObject(parameter) && typeof parameter.name === 'string') {
        stagedBody.append(parameter.name, parameter.value == null ? '' : String(parameter.value));
      }
    });
    var preparedFilename = typeof prepared.filename === 'string' && prepared.filename
      ? prepared.filename : requestedFilename;
    stagedBody.append('file', blob, preparedFilename);
    var stagedResponse = await fetchWithTimeout(prepared.url, {
      method: 'POST',
      body: stagedBody
    }, REQUEST_TIMEOUT_MS);
    if (!stagedResponse.ok) throw new Error('Could not upload ' + key + ' mockup directly to Shopify');

    var finalizeResponse = await fetchWithTimeout(SHOPIFY_UPLOAD_API_BASE_URL + '/api/shopify-finalize-upload', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        resource_url: prepared.resourceUrl,
        filename: preparedFilename
      })
    }, REQUEST_TIMEOUT_MS);
    var finalized = await finalizeResponse.json().catch(function () { return {}; });
    if (
      !finalizeResponse.ok || !isObject(finalized) || finalized.cdn !== 'shopify' ||
      typeof finalized.url !== 'string' || !finalized.url
    ) {
      throw new Error('Could not finalize ' + key + ' mockup upload');
    }
    return finalized.url;
  }

  async function composeAndUploadTshirtVariousMockup(template, artworkUrl, key, label) {
    var mockup = template.mockups.find(function (item) { return item.key === key; });
    var lastError;
    for (var attempt = 1; attempt <= 2; attempt += 1) {
      try {
        var startedAt = performance.now();
        var blob = await composeTshirtVariousMockup(mockup, artworkUrl);
        var composedAt = performance.now();
        var url = await uploadTshirtVariousMockup(blob, key);
        var uploadedAt = performance.now();
        console.info('[HavJoy] ' + label + ' ' + key + ' mockup | compose ' +
          ((composedAt - startedAt) / 1000).toFixed(1) + 's | upload ' +
          ((uploadedAt - composedAt) / 1000).toFixed(1) + 's | ' +
          Math.round(blob.size / 1024) + ' KB');
        return url;
      } catch (error) {
        lastError = error;
        if (attempt < 2) await wait(1000);
      }
    }
    throw lastError || new Error('Could not prepare ' + key + ' mockup');
  }

  function normalizeTemplate(payload) {
    if (!isObject(payload)) return null;
    const validTemplate =
      payload.success &&
      payload.template_id &&
      Array.isArray(payload.slots) &&
      Array.isArray(payload.mockups);
    if (!validTemplate) return null;
    var raw = payload;
    if (!Array.isArray(raw.slots) || !Array.isArray(raw.mockups) || !raw.mockups.length) return null;
    if (!isObject(raw.upload)) return null;
    if (!Array.isArray(raw.upload.types) || !Number.isInteger(raw.upload.max_bytes) || raw.upload.max_bytes < 1) return null;

    var mockupKeys = [];
    var mockups = [];
    raw.mockups.forEach(function (mockup) {
      if (
        isObject(mockup) &&
        typeof mockup.key === 'string' &&
        mockup.key &&
        typeof mockup.variant_name === 'string' &&
        mockupKeys.indexOf(mockup.key) === -1
      ) {
        var printArea = mockup.print_area;
        var printX = isObject(printArea) ? Number(printArea.x) : NaN;
        var printY = isObject(printArea) ? Number(printArea.y) : NaN;
        var printW = isObject(printArea) ? Number(printArea.w) : NaN;
        var printH = isObject(printArea) ? Number(printArea.h) : NaN;
        var templateUrl = typeof mockup.url === 'string' ? mockup.url.trim() : '';
        var templateWidth = Number(mockup.width);
        var templateHeight = Number(mockup.height);
        var templateGarmentScale = mockup.garment_scale == null ? 1 : Number(mockup.garment_scale);
        if (
          ![printX, printY, printW, printH].every(Number.isFinite) ||
          printX < 0 || printY < 0 || printW <= 0 || printH <= 0 ||
          printX + printW > 1 || printY + printH > 1 ||
          !/^https:\/\//i.test(templateUrl) ||
          !Number.isFinite(templateWidth) || templateWidth <= 0 ||
          !Number.isFinite(templateHeight) || templateHeight <= 0 ||
          !Number.isFinite(templateGarmentScale) ||
          templateGarmentScale < 0.5 || templateGarmentScale > 2.5
        ) return;
        mockupKeys.push(mockup.key);
        mockups.push({
          key: mockup.key,
          variantName: mockup.variant_name,
          templateUrl: templateUrl,
          templateWidth: templateWidth,
          templateHeight: templateHeight,
          templateGarmentScale: templateGarmentScale,
          templatePrintArea: { x: printX, y: printY, w: printW, h: printH },
          overlay: null
        });
      }
    });
    if (mockupKeys.length !== raw.mockups.length) return null;
    if (typeof raw.default_mockup_key !== 'string' || mockupKeys.indexOf(raw.default_mockup_key) === -1) return null;

    var slotKeys = [];
    var slots = [];
    for (var index = 0; index < raw.slots.length; index += 1) {
      var slot = raw.slots[index];
      if (!isObject(slot) || typeof slot.key !== 'string' || !slot.key || slotKeys.indexOf(slot.key) !== -1) return null;
      var type = slot.type === 'image' ? 'image' : ((slot.type === 'text' || slot.binding === 'prompt') ? 'text' : null);
      if (!type) return null;
      var minLength = slot.min_length == null ? null : Number(slot.min_length);
      var maxLength = slot.max_length == null ? null : Number(slot.max_length);
      if (minLength !== null && (!Number.isInteger(minLength) || minLength < 0)) return null;
      if (maxLength !== null && (!Number.isInteger(maxLength) || maxLength < 1)) return null;
      if (minLength !== null && maxLength !== null && minLength > maxLength) return null;
      slotKeys.push(slot.key);
      slots.push({
        key: slot.key,
        type: type,
        label: typeof slot.label === 'string' && slot.label ? slot.label : slot.key,
        required: slot.required === true,
        minLength: minLength,
        maxLength: maxLength
      });
    }

    var uploadTypes = raw.upload.types.length ? raw.upload.types.map(function (type) {
      return typeof type === 'string' ? type.toLowerCase() : '';
    }) : DEFAULT_IMAGE_TYPES.slice();
    if (!uploadTypes.length || uploadTypes.some(function (type) { return type.indexOf('image/') !== 0; })) return null;

    return {
      templateId: raw.template_id,
      slots: slots,
      mockups: mockups,
      mockupKeys: mockupKeys,
      defaultMockupKey: raw.default_mockup_key,
      upload: { types: uploadTypes, maxBytes: Math.min(raw.upload.max_bytes, CUSTOMER_IMAGE_MAX_INPUT_BYTES) }
    };
  }

  function inferMime(file) {
    if (file.type) return file.type.toLowerCase();
    var extension = (file.name.split('.').pop() || '').toLowerCase();
    return {
      jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp',
      heic: 'image/heic', heif: 'image/heif'
    }[extension] || '';
  }

  function isHeicFile(file) {
    var type = String(file && file.type || '').toLowerCase();
    var name = String(file && file.name || '');
    return type.indexOf('heic') !== -1 || type.indexOf('heif') !== -1 || /\.(heic|heif)$/i.test(name);
  }

  function ensureHeicConverter() {
    if (typeof window.heic2any === 'function') return Promise.resolve(window.heic2any);
    if (HEIC_CONVERTER_PROMISE) return HEIC_CONVERTER_PROMISE;
    HEIC_CONVERTER_PROMISE = new Promise(function (resolve, reject) {
      var source = window.HavjoyHeic2anyUrl;
      if (!source) {
        reject(new Error('HEIC converter is not available'));
        return;
      }
      var script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.onload = function () {
        if (typeof window.heic2any === 'function') resolve(window.heic2any);
        else reject(new Error('HEIC converter could not be loaded'));
      };
      script.onerror = function () { reject(new Error('HEIC converter could not be loaded')); };
      document.head.appendChild(script);
    }).catch(function (error) {
      HEIC_CONVERTER_PROMISE = null;
      throw error;
    });
    return HEIC_CONVERTER_PROMISE;
  }

  function loadCustomerImage(blob) {
    return new Promise(function (resolve, reject) {
      var objectUrl = URL.createObjectURL(blob);
      var image = new Image();
      image.onload = function () {
        URL.revokeObjectURL(objectUrl);
        resolve(image);
      };
      image.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('The selected image cannot be decoded'));
      };
      image.src = objectUrl;
    });
  }

  function customerCanvasToJpeg(canvas) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (blob) resolve(blob);
        else reject(new Error('JPEG encoding failed'));
      }, 'image/jpeg', CUSTOMER_IMAGE_JPEG_QUALITY);
    });
  }

  async function normalizeCustomerImage(file) {
    var source = file;
    if (isHeicFile(file)) {
      var convertHeic = await ensureHeicConverter();
      source = await convertHeic({
        blob: file,
        toType: 'image/jpeg',
        quality: CUSTOMER_IMAGE_JPEG_QUALITY
      });
      if (Array.isArray(source)) source = source[0];
      if (!(source instanceof Blob)) throw new Error('HEIC conversion failed');
    }

    var image = await loadCustomerImage(source);
    var sourceWidth = Number(image.naturalWidth || image.width);
    var sourceHeight = Number(image.naturalHeight || image.height);
    if (!Number.isFinite(sourceWidth) || sourceWidth < 1 || !Number.isFinite(sourceHeight) || sourceHeight < 1) {
      throw new Error('The selected image has invalid dimensions');
    }
    var scale = Math.min(1, CUSTOMER_IMAGE_MAX_DIMENSION / Math.max(sourceWidth, sourceHeight));
    var width = Math.max(1, Math.round(sourceWidth * scale));
    var height = Math.max(1, Math.round(sourceHeight * scale));
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var context = canvas.getContext('2d', { alpha: false });
    if (!context) throw new Error('Canvas is not available');
    context.fillStyle = '#fff';
    context.fillRect(0, 0, width, height);
    context.drawImage(image, 0, 0, width, height);
    return {
      blob: await customerCanvasToJpeg(canvas),
      width: width,
      height: height,
      originalWidth: sourceWidth,
      originalHeight: sourceHeight
    };
  }

  async function readCustomerUploadResponse(response, label) {
    var payload = await response.json().catch(function () { return {}; });
    if (!response.ok) {
      var message = typeof payload.error === 'string' && payload.error
        ? payload.error
        : (typeof payload.errorMessage === 'string' && payload.errorMessage
          ? payload.errorMessage
          : label + ' failed (' + response.status + ')');
      throw new Error(message);
    }
    return payload;
  }

  async function prepareCustomerShopifyUpload(fileSize) {
    var response = await fetchWithTimeout(API_BASE_URL + '/api/shopify-prepare-upload', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ mime_type: 'image/jpeg', file_size: fileSize || 0 })
    }, REQUEST_TIMEOUT_MS);
    var target = await readCustomerUploadResponse(response, 'Prepare upload');
    if (
      target.fallback === true || typeof target.url !== 'string' || !target.url ||
      typeof target.resourceUrl !== 'string' || !target.resourceUrl ||
      !Array.isArray(target.parameters)
    ) throw new Error('Invalid Shopify staged upload target');
    return target;
  }

  async function uploadCustomerBlobToShopify(target, jpegBlob) {
    var form = new FormData();
    target.parameters.forEach(function (parameter) {
      if (isObject(parameter) && typeof parameter.name === 'string') {
        form.append(parameter.name, parameter.value == null ? '' : String(parameter.value));
      }
    });
    var filename = typeof target.filename === 'string' && target.filename ? target.filename : 'customer.jpg';
    form.append('file', jpegBlob, filename);
    var response = await fetchWithTimeout(target.url, { method: 'POST', body: form }, REQUEST_TIMEOUT_MS);
    if (!response.ok && response.status !== 201) {
      throw new Error('Shopify staged upload failed (' + response.status + ')');
    }
  }

  async function finalizeCustomerShopifyUpload(target) {
    var filename = typeof target.filename === 'string' && target.filename ? target.filename : 'customer.jpg';
    var response = await fetchWithTimeout(API_BASE_URL + '/api/shopify-finalize-upload', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ resource_url: target.resourceUrl, filename: filename })
    }, REQUEST_TIMEOUT_MS);
    var result = await readCustomerUploadResponse(response, 'Finalize upload');
    if (typeof result.url !== 'string' || !result.url) throw new Error('Finalize upload returned no URL');
    return result;
  }

  async function fallbackCustomerShopifyUpload(jpegBlob) {
    var form = new FormData();
    form.append('file', jpegBlob, 'customer.jpg');
    var response = await fetchWithTimeout(API_BASE_URL + '/api/product-template-upload', {
      method: 'POST',
      body: form
    }, REQUEST_TIMEOUT_MS);
    var result = await readCustomerUploadResponse(response, 'Fallback upload');
    if (typeof result.url !== 'string' || !result.url) throw new Error('Fallback upload returned no URL');
    return result;
  }

  async function uploadCustomerImage(file, onStage) {
    onStage = typeof onStage === 'function' ? onStage : function () {};
    onStage('Optimizing image...');
    var earlyTargetPromise = prepareCustomerShopifyUpload(0).catch(function () { return null; });
    var normalized = await normalizeCustomerImage(file);
    console.info('[HavJoy] customer image optimized | ' + normalized.originalWidth + 'x' + normalized.originalHeight +
      ' -> ' + normalized.width + 'x' + normalized.height + ' | ' + Math.round(normalized.blob.size / 1024) + ' KB JPEG');
    var target = await earlyTargetPromise;
    try {
      if (!target) target = await prepareCustomerShopifyUpload(normalized.blob.size);
      onStage('Uploading image...');
      await uploadCustomerBlobToShopify(target, normalized.blob);
      onStage('Finishing upload...');
      var finalized = await finalizeCustomerShopifyUpload(target);
      return {
        url: finalized.url,
        cdn: finalized.cdn || 'shopify',
        width: normalized.width,
        height: normalized.height
      };
    } catch (directUploadError) {
      console.warn('[HavJoy] Direct Shopify customer upload failed; using server fallback', directUploadError);
      onStage('Finishing upload...');
      var fallback = await fallbackCustomerShopifyUpload(normalized.blob);
      return {
        url: fallback.url,
        cdn: fallback.cdn || '',
        width: normalized.width,
        height: normalized.height
      };
    }
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function productTypeIconMarkup(value) {
    var key = String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ');
    if (key === 't shirt' || key === 'tshirt' || key === 'tee') {
      return '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><path d="M22 11c1.9 4 5.2 6 10 6s8.1-2 10-6l12 7-7 12-6-4v27H23V26l-6 4-7-12 12-7Z"/><path d="M24 12c1 2.2 3.7 3.5 8 3.5s7-1.3 8-3.5"/></svg>';
    }
    if (key === 'hoodie') {
      return '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><path d="M23 16c1.2-6 4.2-9 9-9s7.8 3 9 9l9 6 6 23-9 3-5-14v20H22V34l-5 14-9-3 6-23 9-6Z"/><path d="M24 16c1.8 3.2 4.5 4.8 8 4.8s6.2-1.6 8-4.8M25 45h14l4 6H21l4-6Z"/><path d="m28 21-2 11m10-11 2 11"/></svg>';
    }
    if (key === 'sweatshirt' || key === 'sweater') {
      return '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><path d="M23 12c1.8 3.5 4.8 5.2 9 5.2s7.2-1.7 9-5.2l9 5 7 24-9 3-6-16v26H22V28l-6 16-9-3 7-24 9-5Z"/><path d="M24 13c1.2 1.7 3.9 2.6 8 2.6s6.8-.9 8-2.6M22 49h20"/></svg>';
    }
    if (key === 'tank top' || key === 'tank' || key === 'singlet') {
      return '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><path d="M24 10c1.2 3.5 3.8 5.2 8 5.2s6.8-1.7 8-5.2h6c0 8 1.5 13.5 5 17v27H13V27c3.5-3.5 5-9 5-17h6Z"/><path d="M24 10c0 7-2 11-6 14m22-14c0 7 2 11 6 14M17 49h30"/></svg>';
    }
    return '';
  }

  function hydrateProductTypeIcons(container) {
    if (!container) return;
    container.querySelectorAll('[data-hjv2-product-type-value]').forEach(function (button) {
      var icon = button.querySelector('[data-hjv2-product-type-icon]');
      if (!icon) return;
      var markup = productTypeIconMarkup(button.dataset.hjv2ProductTypeValue);
      icon.innerHTML = markup;
      icon.hidden = !markup;
      button.classList.toggle('has-no-icon', !markup);
    });
  }

  function syncProductTypeButtons(container, product, optionInputs) {
    if (!container || !product || !Array.isArray(product.variants)) return;
    var inputs = Array.prototype.slice.call(optionInputs || []);
    var selectedValues = [];
    inputs.forEach(function (input) {
      var rawIndex = input.dataset.hjv2OptionIndex;
      if (rawIndex == null) rawIndex = input.dataset.hjv2BundleOptionIndex;
      var index = parseInt(rawIndex, 10);
      if (Number.isInteger(index)) selectedValues[index] = input.value;
    });
    container.querySelectorAll('[data-hjv2-product-type-value]').forEach(function (button) {
      var index = parseInt(button.dataset.hjv2ProductTypeIndex, 10);
      var value = button.dataset.hjv2ProductTypeValue || '';
      var selected = selectedValues[index] === value;
      var available = product.variants.some(function (variant) {
        return variant.available && Array.isArray(variant.options) && variant.options.every(function (variantValue, optionIndex) {
          if (optionIndex === index) return variantValue === value;
          return selectedValues[optionIndex] == null || variantValue === selectedValues[optionIndex];
        });
      });
      button.disabled = !available;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.setAttribute('aria-disabled', available ? 'false' : 'true');
    });
  }

  function normalizeProduct(raw, fallback) {
    fallback = fallback || {};
    if (!isObject(raw) || !Array.isArray(raw.variants)) return null;
    var optionNames = Array.isArray(raw.options) ? raw.options.map(function (option) {
      if (typeof option === 'string') return option;
      return isObject(option) && typeof option.name === 'string' ? option.name : '';
    }).filter(Boolean) : [];
    var variants = raw.variants.map(function (variant) {
      if (!isObject(variant) || variant.id == null || !Array.isArray(variant.options)) return null;
      return {
        id: String(variant.id),
        options: variant.options.map(String),
        price: Number(variant.price) || 0,
        available: variant.available !== false
      };
    }).filter(Boolean);
    if (!variants.length) return null;
    return {
      handle: String(raw.handle || raw.product_handle || fallback.handle || ''),
      title: String(raw.title || fallback.title || 'Custom tee'),
      image: String(raw.featured_image || fallback.image || ''),
      options: optionNames,
      variants: variants
    };
  }

  function discountRate(quantity, builder) {
    var secondPercent = builder ? Number(builder.dataset.discountPct) : NaN;
    var thirdPercent = builder ? Number(builder.dataset.discountPct3) : NaN;
    if (!Number.isFinite(secondPercent)) secondPercent = 15;
    if (!Number.isFinite(thirdPercent)) thirdPercent = 20;
    secondPercent = Math.max(0, Math.min(100, secondPercent));
    thirdPercent = Math.max(0, Math.min(100, thirdPercent));
    if (quantity >= 3) return thirdPercent / 100;
    if (quantity >= 2) return secondPercent / 100;
    return 0;
  }

  function init(root) {
    if (!root || root.dataset.hjv2Initialized === 'true') return;
    var scope = root.closest('.hj-personalize-scope');
    var form = root.closest('form[action*="/cart/add"]');
    var productRoot = scope && scope.querySelector('.hj-tee-product');
    var modal = scope && scope.querySelector('#personalize-modal');
    var fileInput = scope && scope.querySelector('#file-input');
    var productData = parseJsonElement('Hjv2ProductData-' + root.dataset.sectionId);
    if (!scope || !form || !productRoot || !modal || !fileInput || !productData || !Array.isArray(productData.variants)) return;
    var mainProduct = normalizeProduct(productData, {
      handle: productData.product_handle,
      title: productData.title,
      image: productData.featured_image
    });
    if (!mainProduct) return;

    var elements = {
      dynamicForm: modal.querySelector('.dynamic-options-form'),
      optionsContainer: modal.querySelector('.product-options-container'),
      confirm: modal.querySelector('.confirm-btn'),
      confirmText: modal.querySelector('.confirm-btn .btn-text'),
      footer: modal.querySelector('.modal-footer'),
      close: modal.querySelector('[data-close]'),
      status: modal.querySelector('.upload-status'),
      statusText: modal.querySelector('.upload-status .status-text'),
      statusBar: modal.querySelector('.upload-status .status-bar'),
      singlePicker: modal.querySelector('[data-single-photo-picker]'),
      singleGrid: modal.querySelector('[data-single-photo-grid]'),
      reuseUpload: modal.querySelector('[data-reuse-upload-note]'),
      cards: modal.querySelector('.img-cards'),
      card: modal.querySelector('.hacard'),
      mainImage: modal.querySelector('.main-image'),
      modalPreview: modal.querySelector('[data-hjv2-modal-preview]'),
      loading: modal.querySelector('.loading-area'),
      note: modal.querySelector('.small-note'),
      designActions: modal.querySelector('.hj-design-actions'),
      atc: productRoot.querySelector('[data-atc-button]'),
      atcText: productRoot.querySelector('[data-atc-text]'),
      atcPrice: productRoot.querySelector('[data-atc-price]'),
      mockupStatus: productRoot.querySelector('[data-tee-mockup-status]'),
      bnpl: productRoot.querySelector('[data-tee-bnpl]'),
      gallery: productRoot.querySelector('.hj-tee-gallery__image'),
      galleryThumbs: productRoot.querySelector('.hj-tee-gallery__thumbs'),
      pdpPreview: productRoot.querySelector('[data-hjv2-pdp-preview]'),
      optionInputs: Array.prototype.slice.call(productRoot.querySelectorAll('[data-hjv2-option-index]')),
      quantity: productRoot.querySelector('[data-tee1-qty]'),
      variantId: form.querySelector('input[name="id"]'),
      live: root.querySelector('[data-hjv2-live]'),
      saving: productRoot.querySelector('[data-tee-saving]'),
      savingText: productRoot.querySelector('[data-tee-saving-text]'),
      atcOriginalPrice: productRoot.querySelector('[data-atc-original-price]'),
      bundleBuilder: productRoot.querySelector('[data-tee-set-builder]'),
      bundleEmpty: productRoot.querySelector('[data-tee-set-empty]'),
      bundleReady: productRoot.querySelector('[data-tee-set-ready]'),
      bundleCards: productRoot.querySelector('[data-tee-set-cards]'),
      bundleCardTemplate: productRoot.querySelector('[data-tee-set-card-template]'),
      bundlePicker: scope.querySelector('[data-tee-set-picker]')
    };
    if (!elements.dynamicForm || !elements.confirm || !elements.mainImage || !elements.atc || !elements.variantId) return;
    root.dataset.hjv2Initialized = 'true';
    if (!elements.mockupStatus) {
      elements.mockupStatus = document.createElement('p');
      elements.mockupStatus.className = 'hj-tee-info__mockup-status caption-small';
      elements.mockupStatus.dataset.teeMockupStatus = '';
      elements.mockupStatus.setAttribute('role', 'status');
      elements.mockupStatus.setAttribute('aria-live', 'polite');
      elements.mockupStatus.hidden = true;
      elements.atc.insertAdjacentElement('afterend', elements.mockupStatus);
    }

    var productTypeOptionIndex = Array.isArray(productData.options)
      ? productData.options.findIndex(function (name) {
        return typeof name === 'string' && name.trim().toLowerCase() === 'product type';
      })
      : -1;

    var state = {
      template: null,
      values: {},
      inputs: {},
      uploadVersions: {},
      uploadsInFlight: 0,
      generation: 0,
      completed: null,
      processing: false,
      addingToCart: false,
      previewUrl: '',
      localPhotoPreviewUrl: '',
      modalStage: 'upload'
    };
    var bundle = {
      slots: [],
      nextId: 2,
      activeSlot: null,
      productCache: {}
    };
    var userAgent = navigator.userAgent || '';
    var isSafari = /AppleWebKit/i.test(userAgent) && /Version\/[\d.]+.*Safari/i.test(userAgent) &&
      !/(Chrome|Chromium|CriOS|Firefox|FxiOS|Edg|EdgiOS|OPiOS|Android)/i.test(userAgent);
    bundle.productCache[mainProduct.handle] = mainProduct;
    var mainOptionControls = productRoot.querySelector('.hj-tee-info__size-qty');
    hydrateProductTypeIcons(mainOptionControls);
    syncProductTypeButtons(mainOptionControls, mainProduct, elements.optionInputs);

    function setLive(message) {
      if (elements.live) elements.live.textContent = message || '';
    }

    function setMockupStatus(message, status) {
      if (!elements.mockupStatus) return;
      elements.mockupStatus.textContent = message || '';
      elements.mockupStatus.hidden = !message;
      if (status) elements.mockupStatus.dataset.status = status;
      else delete elements.mockupStatus.dataset.status;
    }

    function setStatus(message, active) {
      if (elements.statusText) elements.statusText.textContent = message || '';
      if (elements.status) elements.status.classList.toggle('active', !!active);
      if (elements.statusBar) elements.statusBar.style.display = 'none';
      setLive(message);
    }

    function clearError() {
      var error = elements.dynamicForm.querySelector('.hjv2-modal-error');
      if (error) error.remove();
    }

    function showError(message) {
      clearError();
      var error = document.createElement('div');
      error.className = 'hjv2-modal-error';
      error.setAttribute('role', 'alert');
      error.textContent = message;
      elements.dynamicForm.prepend(error);
      setLive(message);
    }

    function setStep(step) {
      modal.querySelectorAll('.hj-step').forEach(function (node) {
        var nodeStep = Number(node.dataset.step);
        node.classList.toggle('active', nodeStep === step);
        node.classList.toggle('done', nodeStep < step);
        var dot = node.querySelector('.hj-step-dot');
        if (dot) dot.innerHTML = nodeStep < step ? '&#10003;' : String(nodeStep);
      });
    }

    function openModal() {
      if (!modal.open) {
        try { modal.showModal(); }
        catch (error) { modal.setAttribute('open', ''); }
      }
      document.documentElement.classList.add('overflow-hidden');
    }

    function releaseModalScroll() {
      document.documentElement.classList.remove('overflow-hidden');
    }

    function releaseModalFocus() {
      var activeElement = document.activeElement;
      if (activeElement && modal.contains(activeElement) && typeof activeElement.blur === 'function') {
        activeElement.blur();
      }
    }

    function closeModal() {
      releaseModalFocus();
      if (modal.open && typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
      releaseModalScroll();
    }

    function closeSafariModalBeforePageUpdate(owner) {
      if (!isSafari || !isModalOwner(owner) || !modal.open) return Promise.resolve(null);
      var position = {
        x: window.scrollX || window.pageXOffset || 0,
        y: window.scrollY || window.pageYOffset || 0
      };
      closeModal();
      return new Promise(function (resolve) {
        window.requestAnimationFrame(function () {
          var hadTabIndex = productRoot.hasAttribute('tabindex');
          var previousTabIndex = productRoot.getAttribute('tabindex');
          productRoot.setAttribute('tabindex', '-1');
          try { productRoot.focus({ preventScroll: true }); }
          catch (error) { productRoot.focus(); }
          if (hadTabIndex) productRoot.setAttribute('tabindex', previousTabIndex);
          else productRoot.removeAttribute('tabindex');
          window.scrollTo(position.x, position.y);
          resolve(position);
        });
      });
    }

    function preserveSafariPagePosition(position) {
      if (!position) return;
      window.requestAnimationFrame(function () {
        window.scrollTo(position.x, position.y);
      });
    }

    function modalOwner() {
      return bundle.activeSlot || state;
    }

    function isModalOwner(owner) {
      return owner === state ? !bundle.activeSlot : bundle.activeSlot === owner;
    }

    function revokeLocalPhotoPreview(owner) {
      if (!owner || typeof owner.localPhotoPreviewUrl !== 'string' || owner.localPhotoPreviewUrl.indexOf('blob:') !== 0) return;
      var localUrl = owner.localPhotoPreviewUrl;
      URL.revokeObjectURL(localUrl);
      owner.localPhotoPreviewUrl = '';
      if (owner.photoPreviewUrl === localUrl) owner.photoPreviewUrl = '';
      if (owner === state && owner.previewUrl === localUrl) owner.previewUrl = '';
    }

    function setLocalPhotoPreview(owner, file) {
      revokeLocalPhotoPreview(owner);
      var localUrl = URL.createObjectURL(file);
      owner.localPhotoPreviewUrl = localUrl;
      owner.photoPreviewUrl = localUrl;
      if (owner === state) owner.previewUrl = localUrl;
      return localUrl;
    }

    function renderSinglePhoto() {
      var owner = modalOwner();
      var previewUrl = owner.photoPreviewUrl || owner.previewUrl || '';
      if (elements.singlePicker) {
        var pickerHead = elements.singlePicker.querySelector('.hj-multi-upload__head');
        if (pickerHead) pickerHead.hidden = !!previewUrl;
      }
      if (elements.singleGrid) {
        elements.singleGrid.innerHTML = '';
        if (previewUrl) {
          var tile = document.createElement('div');
          tile.className = 'hj-multi-upload__tile';
          var photo = document.createElement('img');
          photo.src = previewUrl;
          photo.alt = 'Uploaded photo';
          tile.appendChild(photo);
          elements.singleGrid.appendChild(tile);
        }
      }
      if (elements.reuseUpload) elements.reuseUpload.hidden = !previewUrl;
    }

    function templateHasDetailFields(template) {
      if (!template || !Array.isArray(template.slots)) return false;
      var primaryImageSeen = false;
      return template.slots.some(function (field) {
        if (field.type !== 'image') return true;
        if (!primaryImageSeen) {
          primaryImageSeen = true;
          return false;
        }
        return true;
      });
    }

    function syncUploadConfirmState(owner) {
      if (!owner || !isModalOwner(owner) || !elements.confirm) return;
      if (owner.modalStage === 'upload') {
        elements.confirm.disabled = owner.uploadsInFlight > 0 || !(owner.photoPreviewUrl || owner.previewUrl);
      } else if (owner.modalStage === 'details') {
        elements.confirm.disabled = owner.uploadsInFlight > 0;
      }
    }

    function showUploadStep() {
      var owner = modalOwner();
      resetLoadingVisual(owner);
      owner.modalStage = 'upload';
      setStep(1);
      if (elements.optionsContainer) elements.optionsContainer.style.display = 'none';
      if (elements.singlePicker) elements.singlePicker.hidden = false;
      renderSinglePhoto();
      if (elements.cards) elements.cards.style.display = 'none';
      if (elements.card) elements.card.style.display = 'none';
      if (elements.mainImage) {
        elements.mainImage.style.display = 'none';
        if (owner.photoPreviewUrl || owner.previewUrl) elements.mainImage.src = owner.photoPreviewUrl || owner.previewUrl;
      }
      if (elements.loading) elements.loading.style.display = 'none';
      if (elements.note) elements.note.style.display = 'none';
      if (elements.designActions) elements.designActions.style.display = 'none';
      if (elements.footer) elements.footer.style.display = '';
      elements.confirm.disabled = owner.uploadsInFlight > 0 || !(owner.photoPreviewUrl || owner.previewUrl);
      elements.confirm.classList.remove('loading');
      if (elements.confirmText) {
        elements.confirmText.textContent = templateHasDetailFields(owner.template) ? 'Next' : 'Generate My Art';
      }
      if (owner.uploadsInFlight === 0) setStatus('', false);
    }

    function showDetails() {
      var owner = modalOwner();
      var hasPhoto = !!(owner.photoPreviewUrl || owner.previewUrl);
      var hasDetailFields = templateHasDetailFields(owner.template);

      resetLoadingVisual(owner);
      owner.modalStage = 'details';
      setStep(2);
      if (elements.optionsContainer) elements.optionsContainer.style.display = hasDetailFields ? 'block' : 'none';
      if (elements.singlePicker) elements.singlePicker.hidden = !hasPhoto;
      if (hasPhoto) renderSinglePhoto();
      if (elements.cards) elements.cards.style.display = 'none';
      if (elements.card) elements.card.style.display = 'none';
      if (elements.mainImage) elements.mainImage.style.display = 'none';
      if (elements.loading) elements.loading.style.display = 'none';
      if (elements.note) elements.note.style.display = 'none';
      if (elements.designActions) elements.designActions.style.display = 'none';
      if (elements.footer) elements.footer.style.display = '';
      elements.confirm.disabled = owner.uploadsInFlight > 0;
      elements.confirm.classList.remove('loading');
      if (elements.confirmText) elements.confirmText.textContent = 'Generate My Art';
      if (owner.uploadsInFlight === 0) setStatus('', false);
    }

    function clearLoadingMessageTimer(owner) {
      if (owner && owner.loadingMessageTimer) {
        window.clearInterval(owner.loadingMessageTimer);
        owner.loadingMessageTimer = null;
      }
    }

    function resetLoadingVisual(owner) {
      clearLoadingMessageTimer(owner);
      if (!elements.loading) return;
      elements.loading.classList.remove('with-photo');
      elements.loading.style.backgroundImage = '';
      var progress = elements.loading.querySelector('.progress-bar');
      if (progress) progress.style.display = 'none';
    }

    function showProcessing() {
      var owner = modalOwner();
      releaseModalFocus();
      resetLoadingVisual(owner);
      owner.modalStage = 'processing';
      setStep(3);
      if (elements.optionsContainer) elements.optionsContainer.style.display = 'none';
      if (elements.singlePicker) elements.singlePicker.hidden = true;
      if (elements.cards) elements.cards.style.display = 'block';
      if (elements.card) elements.card.style.display = 'block';
      elements.mainImage.style.display = 'none';
      if (elements.loading) {
        var sourcePhoto = owner.photoPreviewUrl || owner.previewUrl || '';
        elements.loading.style.display = 'flex';
        if (sourcePhoto) {
          elements.loading.style.backgroundImage = 'url("' + String(sourcePhoto).replace(/"/g, '%22') + '")';
          elements.loading.classList.add('with-photo');
        }
        var loadingText = elements.loading.querySelector('.loading-text');
        var loadingMessages = [
          'Analyzing your photo...',
          'Sketching the outline...',
          'Adding colors and details...',
          'Our artist is adding the final touches...',
          'Almost done — your portrait is coming to life!'
        ];
        if (loadingText) {
          var messageIndex = 0;
          loadingText.textContent = loadingMessages[messageIndex];
          owner.loadingMessageTimer = window.setInterval(function () {
            if (!isModalOwner(owner)) return;
            messageIndex = Math.min(messageIndex + 1, loadingMessages.length - 1);
            loadingText.textContent = loadingMessages[messageIndex];
          }, 6000);
        }
      }
      if (elements.note) elements.note.style.display = '';
      if (elements.designActions) elements.designActions.style.display = 'none';
      if (elements.footer) elements.footer.style.display = '';
      elements.confirm.disabled = true;
      elements.confirm.classList.add('loading');
      if (elements.confirmText) elements.confirmText.textContent = 'Creating Preview';
      setStatus('', false);
      setLive('Creating your preview…');
      setMockupStatus('Creating your preview…', 'processing');
    }

    function selectedVariant() {
      var id = String(elements.variantId.value || '');
      return mainProduct.variants.find(function (variant) { return String(variant.id) === id; }) || null;
    }

    function syncOptionControls(variant) {
      if (!variant || !Array.isArray(variant.options)) return;
      elements.optionInputs.forEach(function (input) {
        var index = parseInt(input.dataset.hjv2OptionIndex, 10);
        if (!Number.isInteger(index) || typeof variant.options[index] !== 'string') return;
        var value = variant.options[index];
        var combo = input.closest('.combo');
        input.value = value;
        if (!combo) return;
        var label = combo.querySelector('.combo-label');
        if (label) label.textContent = value;
        combo.querySelectorAll('.combo-option').forEach(function (item) {
          item.classList.toggle('active', item.dataset.value === value);
        });
      });
      syncProductTypeButtons(mainOptionControls, mainProduct, elements.optionInputs);
    }

    function syncVariantFromOptions() {
      var current = selectedVariant();
      var optionCount = Array.isArray(productData.options) ? productData.options.length : 0;
      var selectedValues = current && Array.isArray(current.options)
        ? current.options.slice(0, optionCount)
        : new Array(optionCount);

      elements.optionInputs.forEach(function (input) {
        var index = parseInt(input.dataset.hjv2OptionIndex, 10);
        if (Number.isInteger(index) && index >= 0 && index < optionCount) selectedValues[index] = input.value;
      });

      var variant = mainProduct.variants.find(function (item) {
        return item.available && Array.isArray(item.options) && selectedValues.every(function (value, index) {
          return item.options[index] === value;
        });
      });

      if (!variant) {
        syncOptionControls(current);
        return current;
      }

      elements.variantId.value = String(variant.id);
      syncOptionControls(variant);
      return variant;
    }

    function mockupByKey(key) {
      return state.template.mockups.find(function (mockup) { return mockup.key === key; }) || null;
    }

    function resolvedMockup(variant) {
      var fallback = mockupByKey(state.template.defaultMockupKey);
      if (!variant || productTypeOptionIndex < 0 || !Array.isArray(variant.options)) return fallback;
      var value = variant.options[productTypeOptionIndex];
      if (typeof value !== 'string') return fallback;
      var trimmedValue = value.trim().toLowerCase();
      return state.template.mockups.find(function (mockup) {
        return mockup.variantName.trim().toLowerCase() === trimmedValue;
      }) || fallback;
    }

    function chooseCompletedMockup() {
      var resolved = resolvedMockup(selectedVariant());
      var key = resolved ? resolved.key : state.template.defaultMockupKey;
      if (!resolved || !resolved.overlay) {
        resolved = mockupByKey(state.template.defaultMockupKey);
        key = resolved ? resolved.key : state.template.defaultMockupKey;
      }
      return resolved && resolved.overlay
        ? { key: key, url: resolved.overlay.url, mockup: resolved }
        : { key: key, url: '', mockup: null };
    }

    function hideOverlayPreview(container) {
      if (!container) return;
      container.hidden = true;
      var mockupImage = container.querySelector('.hj-v2-preview__mockup');
      var artworkImage = container.querySelector('.hj-v2-preview__artwork');
      if (mockupImage) {
        mockupImage.removeAttribute('src');
        mockupImage.style.removeProperty('transform');
        mockupImage.style.removeProperty('transform-origin');
      }
      if (artworkImage) artworkImage.removeAttribute('src');
      container.style.removeProperty('aspect-ratio');
    }

    function setOverlayPreview(container, mockup, artworkUrl) {
      if (!container || !mockup || !mockup.overlay || !artworkUrl) return false;
      var mockupImage = container.querySelector('.hj-v2-preview__mockup');
      var artworkImage = container.querySelector('.hj-v2-preview__artwork');
      if (!mockupImage || !artworkImage) return false;
      var area = mockup.overlay.printArea;
      var garmentScale = mockup.overlay.garmentScale;
      mockupImage.src = mockup.overlay.url;
      mockupImage.width = mockup.overlay.sourceWidth;
      mockupImage.height = mockup.overlay.sourceHeight;
      mockupImage.style.transform = 'scale(' + garmentScale + ')';
      mockupImage.style.transformOrigin = 'center';
      artworkImage.src = artworkUrl;
      artworkImage.style.left = ((0.5 + (area.x - 0.5) * garmentScale) * 100) + '%';
      artworkImage.style.top = ((0.5 + (area.y - 0.5) * garmentScale) * 100) + '%';
      artworkImage.style.width = (area.w * garmentScale * 100) + '%';
      artworkImage.style.height = (area.h * garmentScale * 100) + '%';
      container.style.aspectRatio = mockup.overlay.sourceWidth + ' / ' + mockup.overlay.sourceHeight;
      container.hidden = false;
      return true;
    }

    function applyCompletedMockup() {
      if (!state.completed) return;
      var selected = chooseCompletedMockup();
      if (!selected.url || state.template.mockupKeys.indexOf(selected.key) === -1) return;
      ensureSelectedTshirtVariousMockup(state.completed, state.template, state.generation, null, selected.key);
      state.previewUrl = selected.url;
      if (isModalOwner(state)) {
        setOverlayPreview(elements.modalPreview, selected.mockup, state.completed.artworkUrl);
        elements.mainImage.style.display = 'none';
      }
      setOverlayPreview(elements.pdpPreview, selected.mockup, state.completed.artworkUrl);
      if (elements.gallery) elements.gallery.style.display = 'none';
      if (elements.galleryThumbs) elements.galleryThumbs.style.display = 'none';
      syncPurchaseSummary();
    }

    function tshirtVariousMockupReady(completed, key) {
      return !!completed && isObject(completed.mockupStates) &&
        Object.prototype.hasOwnProperty.call(completed.mockupStates, key) &&
        isObject(completed.mockupUrls) && typeof completed.mockupUrls[key] === 'string' && !!completed.mockupUrls[key];
    }

    function tshirtVariousMockupLabel(key) {
      if (key === 'tshirt') return 'T-shirt';
      if (key === 'hoodie') return 'Hoodie';
      if (key === 'sweatshirt') return 'Sweatshirt';
      if (key === 'tanktop') return 'Tanktop';
      return String(key || 'product').replace(/[-_]+/g, ' ');
    }

    function mockupJobIsCurrent(completed, token, slot) {
      return slot
        ? token === slot.generation && slot.completed === completed && bundle.slots.indexOf(slot) !== -1
        : token === state.generation && state.completed === completed;
    }

    function ensureTshirtVariousMockup(completed, template, token, slot, key) {
      if (!completed || !template || !Array.isArray(template.mockupKeys) || template.mockupKeys.indexOf(key) === -1) {
        return Promise.resolve('');
      }
      if (tshirtVariousMockupReady(completed, key)) return Promise.resolve(completed.mockupUrls[key]);
      if (completed.mockupJobs[key]) return completed.mockupJobs[key];
      var label = slot ? 'bundle #' + slot.id : 'main';
      var startedAt = performance.now();
      completed.mockupStates[key] = 'processing';
      delete completed.mockupErrors[key];
      syncPurchaseSummary();
      var job = composeAndUploadTshirtVariousMockup(
        template,
        completed.artworkUrl,
        key,
        label
      ).then(function (url) {
        if (!mockupJobIsCurrent(completed, token, slot)) return '';
        completed.mockupUrls[key] = url;
        completed.mockupStates[key] = 'ready';
        delete completed.mockupErrors[key];
        delete completed.mockupJobs[key];
        storeCompletedMockupSet(completed, template);
        var currentSelection = slot ? bundleCompletedMockup(slot) : chooseCompletedMockup();
        if (currentSelection && currentSelection.key === key) {
          if (slot) applyBundleCompletedMockup(slot);
          else applyCompletedMockup();
        } else {
          syncPurchaseSummary();
        }
        console.info('[HavJoy] ' + label + ' ' + key + ' mockup ready | ' +
          ((performance.now() - startedAt) / 1000).toFixed(1) + 's | ' + url);
        return url;
      }).catch(function (error) {
        if (!mockupJobIsCurrent(completed, token, slot)) return '';
        completed.mockupStates[key] = 'failed';
        completed.mockupErrors[key] = error.message || 'Mockup preparation failed';
        delete completed.mockupJobs[key];
        syncPurchaseSummary();
        console.error('[HavJoy] ' + label + ' ' + key + ' mockup failed', error);
        return '';
      });
      completed.mockupJobs[key] = job;
      return job;
    }

    function ensureSelectedTshirtVariousMockup(completed, template, token, slot, selectedKey) {
      if (!selectedKey) return;
      ensureTshirtVariousMockup(completed, template, token, slot, selectedKey);
    }

    async function prepareTshirtVariousMockups(completed, template, token, slot) {
      if (!completed || !template || completed.backgroundMockupsStarted) return;
      completed.backgroundMockupsStarted = true;
      var label = slot ? 'bundle #' + slot.id : 'main';
      var selected = slot ? bundleCompletedMockup(slot) : chooseCompletedMockup();
      var priorityKey = selected && selected.key && template.mockupKeys.indexOf(selected.key) !== -1
        ? selected.key
        : template.defaultMockupKey;
      console.info('[HavJoy] ' + label + ' priority mockup started | ' + priorityKey);
      await ensureTshirtVariousMockup(completed, template, token, slot, priorityKey);
      if (!mockupJobIsCurrent(completed, token, slot)) return;
      var backgroundKeys = template.mockupKeys.filter(function (key) { return key !== priorityKey; });
      Promise.all(backgroundKeys.map(function (key) {
        return ensureTshirtVariousMockup(completed, template, token, slot, key);
      })).then(function () {
        if (!mockupJobIsCurrent(completed, token, slot)) return;
        console.info('[HavJoy] ' + label + ' background mockups settled');
      });
    }

    function syncPurchaseSummary() {
      var entries = allPurchaseEntries();
      var quantity = entries.reduce(function (sum, entry) { return sum + entry.quantity; }, 0);
      var subtotal = entries.reduce(function (sum, entry) {
        return sum + (entry.variant ? Number(entry.variant.price) || 0 : 0) * entry.quantity;
      }, 0);
      var rate = discountRate(quantity, productRoot);
      var savings = Math.round(subtotal * rate);
      var total = subtotal - savings;
      var failedEntry = entries.find(function (entry) {
        return entry.completed && entry.mockupKey && entry.completed.mockupStates[entry.mockupKey] === 'failed';
      });
      var generatingPreview = state.processing || bundle.slots.some(function (slot) { return slot.processing; });
      if (elements.atcText) elements.atcText.textContent = 'ADD TO CART';
      if (failedEntry) setMockupStatus('Could not prepare the selected ' + tshirtVariousMockupLabel(failedEntry.mockupKey) + ' mockup. Select it again to retry.', 'failed');
      else if (generatingPreview) setMockupStatus('Creating your preview…', 'processing');
      else setMockupStatus('', '');
      if (elements.atcPrice) elements.atcPrice.textContent = formatMoney(total);
      if (elements.atcOriginalPrice) {
        elements.atcOriginalPrice.textContent = rate ? formatMoney(subtotal) : '';
        elements.atcOriginalPrice.hidden = !rate;
      }
      if (elements.saving) {
        elements.saving.hidden = !(state.completed && savings > 0);
        if (elements.savingText) elements.savingText.textContent = savings > 0
          ? 'You save ' + formatMoney(savings) + (quantity >= 3 ? ' + Free Shipping' : '') : '';
      }
      productRoot.dataset.bundleState = savings > 0 ? 'bundled' : 'single';
      if (elements.bnpl) {
        var threshold = parseInt(elements.bnpl.dataset.bnplThreshold || '3500', 10);
        var eligible = elements.bnpl.querySelector('[data-bnpl-eligible]');
        var ineligible = elements.bnpl.querySelector('[data-bnpl-ineligible]');
        var installmentCount = elements.bnpl.querySelector('#interest_num');
        var installment = elements.bnpl.querySelector('#moneyInstallment');
        var isEligible = total >= threshold;
        var payments = total > 5000 ? 4 : 2;
        if (eligible) eligible.hidden = !isEligible;
        if (ineligible) ineligible.hidden = isEligible;
        if (installmentCount) installmentCount.textContent = String(payments);
        if (installment) installment.textContent = formatMoney(Math.round(total / payments));
      }
      renderBundleCards(entries);
      elements.atc.disabled = state.addingToCart || state.processing || !fieldsValid(state, false) || !bundleReadyForCart(entries);
    }

    function setFieldError(input, message, show) {
      var group = input && input.closest('.form-group');
      var error = group && group.querySelector('.hjv2-field-error');
      if (error) {
        error.textContent = show ? message : '';
        error.hidden = !(show && message);
      }
      if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    function validateField(owner, field, showErrors) {
      var input = owner.inputs[field.key];
      var message = '';
      var value = field.type === 'text' ? (input ? input.value : owner.values[field.key] || '') : owner.values[field.key] || '';
      owner.values[field.key] = value;
      if (field.required && !String(value).trim()) message = field.label + ' is required.';
      else if (field.type === 'text' && value && field.minLength !== null && value.length < field.minLength) {
        message = field.label + ' must be at least ' + field.minLength + ' characters.';
      } else if (field.type === 'text' && field.maxLength !== null && value.length > field.maxLength) {
        message = field.label + ' must be no more than ' + field.maxLength + ' characters.';
      }
      if (input && (owner === state || input !== fileInput)) setFieldError(input, message, showErrors);
      return !message;
    }

    function fieldsValid(owner, showErrors) {
      return owner.template.slots.reduce(function (valid, field) {
        return validateField(owner, field, showErrors) && valid;
      }, true);
    }

    function invalidateResult(options) {
      options = options || {};
      state.generation += 1;
      clearLoadingMessageTimer(state);
      state.completed = null;
      state.processing = false;
      elements.atc.disabled = true;
      hideOverlayPreview(elements.modalPreview);
      hideOverlayPreview(elements.pdpPreview);
      if (elements.gallery) {
        elements.gallery.style.display = 'block';
        if (!options.keepGallery && productData.featured_image) elements.gallery.src = productData.featured_image;
      }
      if (elements.galleryThumbs) elements.galleryThumbs.style.removeProperty('display');
      if (!options.keepMessage) clearError();
      syncPurchaseSummary();
    }

    function renderFields() {
      elements.dynamicForm.innerHTML = '';
      state.inputs = {};
      fileInput.accept = state.template.upload.types.join(',');
      var imageIndex = 0;
      state.template.slots.forEach(function (slot, index) {
        var group = document.createElement('div');
        group.className = 'form-group';
        var id = 'Hjv2ModalField-' + root.dataset.sectionId + '-' + index;
        var label = document.createElement('label');
        label.htmlFor = id;
        label.textContent = slot.label + (slot.required ? ' *' : '');
        group.appendChild(label);

        var input;
        if (slot.type === 'image') {
          imageIndex += 1;
          if (imageIndex === 1) {
            input = fileInput;
            input.dataset.hjv2SlotKey = slot.key;
            state.inputs[slot.key] = input;
            var imageStatus = document.createElement('span');
            imageStatus.className = 'hjv2-extra-file-status';
            imageStatus.dataset.hjv2PrimaryImageStatus = '';
            imageStatus.textContent = state.values[slot.key] ? 'Image uploaded.' : 'Choose your photo from the upload area.';
            group.appendChild(imageStatus);
            group.hidden = true;
          } else {
            input = document.createElement('input');
            input.type = 'file';
            input.id = id;
            input.accept = state.template.upload.types.join(',');
            input.className = 'hjv2-extra-file';
            input.dataset.hjv2SlotKey = slot.key;
            var status = document.createElement('span');
            status.className = 'hjv2-extra-file-status';
            status.textContent = 'Maximum ' + Math.ceil(state.template.upload.maxBytes / 1048576) + ' MB.';
            group.appendChild(input);
            group.appendChild(status);
            input.addEventListener('change', function () {
              uploadPersonalizationFile(state, slot.key, input.files && input.files[0], status, {
                clearValue: true,
                invalidate: function () { invalidateResult({ keepGallery: true }); }
              });
            });
            state.inputs[slot.key] = input;
          }
        } else {
          input = document.createElement('input');
          input.type = 'text';
          input.id = id;
          input.required = slot.required;
          input.dataset.hjv2SlotKey = slot.key;
          input.value = state.values[slot.key] || '';
          if (slot.minLength !== null) input.minLength = slot.minLength;
          if (slot.maxLength !== null) input.maxLength = slot.maxLength;
          input.addEventListener('input', function () {
            state.values[slot.key] = input.value;
            invalidateResult({ keepGallery: true });
            validateField(state, slot, false);
          });
          group.appendChild(input);
          state.inputs[slot.key] = input;
        }

        var fieldError = document.createElement('span');
        fieldError.className = 'hjv2-field-error';
        fieldError.hidden = true;
        group.appendChild(fieldError);
        elements.dynamicForm.appendChild(group);
        if (!Object.prototype.hasOwnProperty.call(state.values, slot.key)) state.values[slot.key] = '';
      });
    }

    async function uploadPersonalizationFile(owner, key, file, statusElement, options) {
      options = options || {};
      if (!file && !options.clearValue) return false;
      owner.uploadVersions[key] = (owner.uploadVersions[key] || 0) + 1;
      var uploadVersion = owner.uploadVersions[key];
      if (options.clearValue) owner.values[key] = '';
      if (options.invalidate) options.invalidate();
      if (!file) return false;

      var mime = inferMime(file);
      if (owner.template.upload.types.indexOf(mime) === -1) {
        if (options.primary) revokeLocalPhotoPreview(owner);
        if (isModalOwner(owner)) showError('Please choose a supported image file.');
        return false;
      }
      if (file.size > owner.template.upload.maxBytes) {
        if (options.primary) revokeLocalPhotoPreview(owner);
        if (isModalOwner(owner)) showError('This image is larger than the allowed upload size.');
        return false;
      }

      owner.uploadsInFlight += 1;
      syncUploadConfirmState(owner);
      if (statusElement) statusElement.textContent = 'Optimizing image...';
      if (isModalOwner(owner)) setStatus('Optimizing image...', true);
      try {
        var uploaded = await uploadCustomerImage(file, function (message) {
          if (owner.uploadVersions[key] !== uploadVersion) return;
          if (statusElement) statusElement.textContent = message;
          if (isModalOwner(owner)) setStatus(message, true);
        });
        if (owner.uploadVersions[key] !== uploadVersion) return false;
        saveRecentUploadedUrl(uploaded.url, !!options.primary);
        owner.values[key] = uploaded.url;
        if (options.primary) {
          revokeLocalPhotoPreview(owner);
          owner.photoPreviewUrl = uploaded.url;
          if (owner === state) owner.previewUrl = uploaded.url;
        }
        if (statusElement) statusElement.textContent = file.name + ' uploaded.';
        if (isModalOwner(owner)) setStatus('', false);
        return true;
      } catch (error) {
        if (owner.uploadVersions[key] === uploadVersion) {
          if (options.clearValue) owner.values[key] = '';
          if (options.primary) revokeLocalPhotoPreview(owner);
          if (statusElement) statusElement.textContent = 'Upload failed. Choose the image to try again.';
          if (isModalOwner(owner)) {
            showError('Could not upload this image. Please try again.');
            setStatus('', false);
          }
        }
        return false;
      } finally {
        owner.uploadsInFlight = Math.max(0, owner.uploadsInFlight - 1);
        syncUploadConfirmState(owner);
      }
    }

    async function handlePrimaryFile(file) {
      var slot = state.template.slots.find(function (item) { return item.type === 'image'; });
      if (!slot || !file) return;
      clearError();
      setLocalPhotoPreview(state, file);
      openModal();
      showUploadStep();
      setStatus('Optimizing image...', true);
      var status = elements.dynamicForm.querySelector('[data-hjv2-primary-image-status]');
      await uploadPersonalizationFile(state, slot.key, file, status, {
        clearValue: true,
        primary: true,
        invalidate: function () { invalidateResult({ keepGallery: true }); }
      });
      if (isModalOwner(state)) showUploadStep();
    }

    function createCompletedResult(template, artworkUrl, originalDesignUrl) {
      var mockupStates = {};
      template.mockupKeys.forEach(function (key) { mockupStates[key] = 'idle'; });
      return {
        artworkUrl: artworkUrl,
        originalDesignUrl: originalDesignUrl || '',
        mockupUrls: {},
        mockupStates: mockupStates,
        mockupErrors: {},
        mockupJobs: {},
        backgroundMockupsStarted: false
      };
    }

    function complete(data, token) {
      if (token !== state.generation) return Promise.resolve();
      if (!isObject(data) || data.status !== 'completed') return Promise.reject(new Error('Invalid completed response'));
      if (typeof data.artwork_url !== 'string' || !data.artwork_url) {
        return Promise.reject(new Error('Missing completed assets'));
      }

      var originalDesignUrl = typeof data.pre_remove_background_url === 'string'
        ? data.pre_remove_background_url.trim() : '';
      var completedResult = createCompletedResult(state.template, data.artwork_url, originalDesignUrl);
      var initialMockup = chooseCompletedMockup();
      if (!initialMockup.mockup || !initialMockup.mockup.overlay) {
        return Promise.reject(new Error('Invalid client overlay template'));
      }

      var preloadUrls = [initialMockup.url, data.artwork_url];
      return Promise.all(preloadUrls.map(preloadImage)).then(async function () {
        if (token !== state.generation) return;
        clearLoadingMessageTimer(state);
        state.processing = false;
        state.completed = completedResult;
        var ownsModal = isModalOwner(state);
        var safariPosition = null;
        if (ownsModal) {
          resetLoadingVisual(state);
          if (elements.loading) elements.loading.style.display = 'none';
          setStatus('Your preview is ready.', false);
          safariPosition = await closeSafariModalBeforePageUpdate(state);
          if (token !== state.generation) return;
        }
        applyCompletedMockup();
        productRoot.dataset.state = 'after-gen';
        preserveSafariPagePosition(safariPosition);
        if (ownsModal && !isSafari) closeModal();
        prepareTshirtVariousMockups(completedResult, state.template, token, null);
      });
    }

    async function pollGenerationJob(config) {
      var deadline = Date.now() + POLL_TIMEOUT_MS;
      var consecutiveRequestFailures = 0;
      while (Date.now() < deadline && config.token === config.owner.generation) {
        var remainingMs = deadline - Date.now();
        var response;
        try {
          response = await fetchWithTimeout(
            JOB_STATUS_API_BASE_URL + '/check_job_status?session_id=' + encodeURIComponent(config.sessionId),
            { method: 'GET', headers: { Accept: 'application/json' } },
            Math.min(REQUEST_TIMEOUT_MS, remainingMs)
          );
        } catch (error) {
          if (Date.now() >= deadline && config.token === config.owner.generation) throw new Error('Generation timed out');
          consecutiveRequestFailures += 1;
          if (consecutiveRequestFailures >= 5) throw error;
          console.warn('[HavJoy] Status poll temporarily unavailable; retrying', consecutiveRequestFailures, error);
          await wait(Math.min(POLL_INTERVAL_MS, deadline - Date.now()));
          continue;
        }
        if (Date.now() >= deadline && config.token === config.owner.generation) throw new Error('Generation timed out');
        if (!response.ok) {
          var retryableStatus = response.status === 404 || response.status === 429 || response.status >= 500;
          consecutiveRequestFailures += 1;
          if (!retryableStatus || consecutiveRequestFailures >= 5) throw new Error('Status request failed');
          console.warn('[HavJoy] Status poll returned ' + response.status + '; retrying', consecutiveRequestFailures);
          await wait(Math.min(POLL_INTERVAL_MS, deadline - Date.now()));
          continue;
        }
        consecutiveRequestFailures = 0;
        var data = await response.json();
        if (config.token !== config.owner.generation) return;
        if (!isObject(data) || typeof data.status !== 'string') throw new Error('Invalid status response');
        if (['processing', 'completed', 'failed'].indexOf(data.status) === -1) throw new Error('Invalid status response');
        logGenerationTiming(config.label, config.sessionId, config.startedAt, data.status, data.progress);
        if (data.status === 'completed') {
          var resultUrl = typeof data.result_url === 'string' ? data.result_url.trim() : '';
          var originalDesignUrl = typeof data.pre_remove_background_url === 'string'
            ? data.pre_remove_background_url.trim() : '';
          if (!resultUrl) throw new Error('Invalid completed response');
          return config.onCompleted(resultUrl, config.sessionId, originalDesignUrl);
        }
        if (data.status === 'failed') {
          var failedMessage = typeof data.error === 'string' && data.error ? data.error : 'Generation failed. Please try again.';
          var failed = new Error(failedMessage);
          failed.publicMessage = failedMessage;
          throw failed;
        }
        if (!config.isActive || config.isActive()) {
          setLive('Creating your preview…');
          var progress = Number(data.progress);
          if (Number.isFinite(progress)) {
            setLive('Creating your preview: ' + Math.max(0, Math.min(100, Math.round(progress))) + '%');
          }
        }
        remainingMs = deadline - Date.now();
        if (remainingMs <= 0) break;
        await wait(Math.min(POLL_INTERVAL_MS, remainingMs));
      }
      if (config.token === config.owner.generation) throw new Error('Generation timed out');
    }

    async function submitGenerationJob(config) {
      var values = {};
      config.template.slots.forEach(function (field) { values[field.key] = config.owner.values[field.key] || ''; });
      var startedAt = performance.now();
      var response = await fetchWithTimeout(API_BASE_URL + '/tshirt-various-mockup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ product_handle: config.productHandle, values: values, source: 'shopify' })
      }, REQUEST_TIMEOUT_MS);
      var data = await response.json();
      if (config.token !== config.owner.generation) return;
      var sessionId = isObject(data) && typeof data.session_id === 'string' ? data.session_id.trim() : '';
      var accepted = response.status === 202 && isObject(data) && data.submitted === true && sessionId &&
        applyTshirtVariousMockups(config.template, data.mockups, data.render_canvas);
      if (!accepted) {
        var errorMessage = isObject(data) && typeof data.errorMessage === 'string'
          ? data.errorMessage : 'The preview service returned invalid mockup data. Please try again.';
        var error = new Error(errorMessage);
        error.publicMessage = errorMessage;
        throw error;
      }
      return pollGenerationJob(Object.assign({}, config, {
        sessionId: sessionId,
        startedAt: startedAt
      }));
    }

    async function generate() {
      clearError();
      if (state.uploadsInFlight > 0) { showError('Please wait for your image to finish uploading.'); return; }
      if (!fieldsValid(state, true)) { showError('Please complete the required fields.'); return; }
      var variant = selectedVariant();
      if (!variant || !variant.available) { showError('Please choose an available size.'); return; }

      invalidateResult({ keepGallery: true, keepMessage: true });
      var token = state.generation;
      state.processing = true;
      syncPurchaseSummary();
      showProcessing();

      try {
        await submitGenerationJob({
          owner: state,
          template: state.template,
          productHandle: productData.product_handle,
          token: token,
          label: 'main generation',
          isActive: function () { return isModalOwner(state); },
          onCompleted: function (artworkUrl, sessionId, originalDesignUrl) {
            return complete({
              status: 'completed',
              artwork_url: artworkUrl,
              pre_remove_background_url: originalDesignUrl
            }, token);
          }
        });
      } catch (error) {
        if (token !== state.generation) return;
        clearLoadingMessageTimer(state);
        state.processing = false;
        syncPurchaseSummary();
        if (isModalOwner(state)) {
          showDetails();
          showError(error.publicMessage || 'We could not create your preview. Please try again.');
          if (elements.confirmText) elements.confirmText.textContent = 'Try Again';
        }
      }
    }

    function mainSourceImageUrl() {
      if (!state.template) return '';
      var imageSlot = state.template.slots.find(function (slot) { return slot.type === 'image'; });
      return imageSlot && typeof state.values[imageSlot.key] === 'string' ? state.values[imageSlot.key] : '';
    }

    function bundleSlotById(slotId) {
      return bundle.slots.find(function (slot) { return String(slot.id) === String(slotId); }) || null;
    }

    function productVariant(product, variantId) {
      if (!product) return null;
      return product.variants.find(function (variant) { return String(variant.id) === String(variantId); }) || null;
    }

    function bundleSelectedVariant(slot) {
      return productVariant(slot.product, slot.variantId);
    }

    function productTypeIndex(product) {
      return product && Array.isArray(product.options) ? product.options.findIndex(function (name) {
        return typeof name === 'string' && name.trim().toLowerCase() === 'product type';
      }) : -1;
    }

    function bundleResolvedMockup(slot) {
      if (!slot.template) return null;
      var fallback = slot.template.mockups.find(function (mockup) {
        return mockup.key === slot.template.defaultMockupKey;
      }) || null;
      var variant = bundleSelectedVariant(slot);
      var index = productTypeIndex(slot.product);
      if (!variant || index < 0) return fallback;
      var value = variant.options[index];
      if (typeof value !== 'string') return fallback;
      var normalizedValue = value.trim().toLowerCase();
      return slot.template.mockups.find(function (mockup) {
        return mockup.variantName.trim().toLowerCase() === normalizedValue;
      }) || fallback;
    }

    function bundleCompletedMockup(slot) {
      if (!slot.completed) return null;
      var resolved = bundleResolvedMockup(slot);
      var key = resolved ? resolved.key : slot.template.defaultMockupKey;
      if (!resolved || !resolved.overlay) {
        resolved = slot.template.mockups.find(function (mockup) { return mockup.key === slot.template.defaultMockupKey; }) || null;
        key = resolved ? resolved.key : slot.template.defaultMockupKey;
      }
      return resolved && resolved.overlay ? { key: key, url: resolved.overlay.url, mockup: resolved } : null;
    }

    function applyBundleCompletedMockup(slot) {
      if (!slot.completed) return;
      var selected = bundleCompletedMockup(slot);
      if (!selected || slot.template.mockupKeys.indexOf(selected.key) === -1) return;
      ensureSelectedTshirtVariousMockup(slot.completed, slot.template, slot.generation, slot, selected.key);
      slot.displayUrl = selected.url;
      syncPurchaseSummary();
    }

    function cartProperties(completed, selected) {
      if (!completed || !selected || !selected.key || !selected.url) return null;
      var selectedMockupUrl = completed.mockupUrls && completed.mockupUrls[selected.key];
      if (typeof selectedMockupUrl !== 'string' || !selectedMockupUrl) return null;
      var properties = { _your_design: selectedMockupUrl };
      if (typeof completed.originalDesignUrl === 'string' && completed.originalDesignUrl) {
        properties._original_design = completed.originalDesignUrl;
      }
      return properties;
    }

    function allPurchaseEntries() {
      var mainVariant = selectedVariant();
      var mainMockup = state.completed ? chooseCompletedMockup() : null;
      var entries = [{
        id: 'main',
        title: mainProduct.title,
        product: mainProduct,
        variant: mainVariant,
        mockupKey: mainMockup ? mainMockup.key : '',
        quantity: elements.quantity ? Math.max(1, parseInt(elements.quantity.value || '1', 10) || 1) : 1,
        completed: state.completed,
        displayUrl: mainMockup ? mainMockup.url : mainProduct.image,
        overlay: mainMockup ? {
          mockup: mainMockup.mockup,
          artworkUrl: state.completed.artworkUrl
        } : null,
        properties: cartProperties(state.completed, mainMockup),
        isMain: true
      }];
      bundle.slots.forEach(function (slot) {
        var selected = slot.completed ? bundleCompletedMockup(slot) : null;
        entries.push({
          id: String(slot.id),
          title: slot.product ? slot.product.title : slot.title,
          product: slot.product,
          variant: bundleSelectedVariant(slot),
          mockupKey: selected ? selected.key : '',
          quantity: Math.max(1, parseInt(slot.quantity || '1', 10) || 1),
          completed: slot.completed,
          displayUrl: slot.displayUrl || (slot.product && slot.product.image) || slot.image,
          overlay: selected ? {
            mockup: selected.mockup,
            artworkUrl: slot.completed.artworkUrl
          } : null,
          properties: cartProperties(slot.completed, selected),
          isMain: false,
          slot: slot
        });
      });
      return entries;
    }

    function bundleReadyForCart(entries) {
      return (entries || allPurchaseEntries()).every(function (entry) {
        return entry.variant && entry.variant.available && entry.completed && entry.properties &&
          tshirtVariousMockupReady(entry.completed, entry.mockupKey) &&
          !(entry.slot && (entry.slot.loading || entry.slot.processing));
      });
    }

    function ordinal(number) {
      if (number === 1) return '1st tee';
      if (number === 2) return '2nd tee';
      if (number === 3) return '3rd tee';
      return number + 'th tee';
    }

    function appendCardOptions(container, entry) {
      if (!container || !entry.product || !entry.variant) return;
      container.innerHTML = '';
      entry.product.options.forEach(function (name, index) {
        var normalizedName = String(name || '').trim().toLowerCase();
        var isProductType = normalizedName === 'product type';
        var field = document.createElement('div');
        field.className = 'hj-tee-set-card__field' +
          (isProductType ? ' hj-tee-set-card__field--product-type' :
            (normalizedName === 'size' ? ' hj-tee-set-card__field--size' : ' hj-tee-set-card__field--other-option'));
        var label = document.createElement('label');
        label.className = 'hj-tee-info__label';
        label.textContent = name;
        field.appendChild(label);
        var values = [];
        entry.product.variants.forEach(function (variant) {
          var value = variant.options[index];
          if (values.indexOf(value) === -1) values.push(value);
        });
        if (isProductType) {
          var group = document.createElement('div');
          group.className = 'hjv2-product-type hjv2-product-type--bundle';
          group.dataset.hjv2ProductTypeGroup = '';
          group.setAttribute('role', 'group');
          group.setAttribute('aria-label', name);
          values.forEach(function (value) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'hjv2-product-type__button' + (value === entry.variant.options[index] ? ' is-selected' : '');
            button.dataset.hjv2ProductTypeValue = value;
            button.dataset.hjv2ProductTypeIndex = String(index);
            button.setAttribute('aria-pressed', value === entry.variant.options[index] ? 'true' : 'false');
            var icon = document.createElement('span');
            icon.className = 'hjv2-product-type__icon';
            icon.dataset.hjv2ProductTypeIcon = '';
            icon.setAttribute('aria-hidden', 'true');
            var valueLabel = document.createElement('span');
            valueLabel.className = 'hjv2-product-type__label';
            valueLabel.textContent = value;
            var check = document.createElement('span');
            check.className = 'hjv2-product-type__check';
            check.setAttribute('aria-hidden', 'true');
            check.textContent = '\u2713';
            button.appendChild(icon);
            button.appendChild(valueLabel);
            button.appendChild(check);
            group.appendChild(button);
          });
          var productTypeInput = document.createElement('input');
          productTypeInput.type = 'hidden';
          productTypeInput.value = entry.variant.options[index] || '';
          productTypeInput.dataset.hjv2BundleOptionIndex = String(index);
          productTypeInput.dataset.hjv2BundleSlotId = entry.id;
          group.appendChild(productTypeInput);
          field.appendChild(group);
          container.appendChild(field);
          return;
        }
        var combo = document.createElement('div');
        combo.className = 'combo hj-size-combo hj-size-combo--set';
        var trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'combo-trigger hj-size-combo__trigger';
        var comboLabel = document.createElement('span');
        comboLabel.className = 'combo-label';
        comboLabel.textContent = entry.variant.options[index] || '';
        trigger.appendChild(comboLabel);
        trigger.insertAdjacentHTML('beforeend', '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>');
        var options = document.createElement('ul');
        options.className = 'combo-options hj-size-combo__options';
        values.forEach(function (value) {
          var item = document.createElement('li');
          item.className = 'combo-option' + (value === entry.variant.options[index] ? ' active' : '');
          item.dataset.value = value;
          item.textContent = value;
          options.appendChild(item);
        });
        var input = document.createElement('input');
        input.type = 'hidden';
        input.className = 'combo-input';
        input.value = entry.variant.options[index] || '';
        input.dataset.hjv2BundleOptionIndex = String(index);
        input.dataset.hjv2BundleSlotId = entry.id;
        combo.appendChild(trigger);
        combo.appendChild(options);
        combo.appendChild(input);
        field.appendChild(combo);
        container.appendChild(field);
      });

      var quantityField = document.createElement('div');
      quantityField.className = 'hj-tee-set-card__field hj-tee-set-card__field--qty';
      var quantityLabel = document.createElement('label');
      quantityLabel.className = 'hj-tee-info__label';
      quantityLabel.textContent = 'Quantity';
      var quantity = document.createElement('div');
      quantity.className = 'hj-tee-info__qty hj-tee-set-card__qty';
      quantity.innerHTML = '<button type="button" data-hjv2-slot-qty-dec aria-label="Decrease quantity">&minus;</button>' +
        '<input type="number" min="1" class="hj-tee-info__qty-input" data-hjv2-slot-qty>' +
        '<button type="button" data-hjv2-slot-qty-inc aria-label="Increase quantity">+</button>';
      quantity.querySelectorAll('button,input').forEach(function (control) {
        control.dataset.hjv2BundleSlotId = entry.id;
      });
      quantity.querySelector('input').value = String(entry.quantity);
      quantityField.appendChild(quantityLabel);
      quantityField.appendChild(quantity);
      container.appendChild(quantityField);
      hydrateProductTypeIcons(container);
      syncProductTypeButtons(
        container,
        entry.product,
        container.querySelectorAll('[data-hjv2-bundle-option-index]')
      );
    }

    function renderBundleCards(entries) {
      if (!elements.bundleBuilder) return;
      entries = entries || allPurchaseEntries();
      var hasAdditional = bundle.slots.length > 0;
      if (elements.bundleEmpty) elements.bundleEmpty.hidden = hasAdditional;
      if (elements.bundleReady) elements.bundleReady.hidden = !hasAdditional;
      productRoot.dataset.teeSetActive = hasAdditional ? 'true' : 'false';
      if (!hasAdditional || !elements.bundleCards || !elements.bundleCardTemplate) return;
      elements.bundleCards.innerHTML = '';
      var totalQuantity = entries.reduce(function (sum, entry) { return sum + entry.quantity; }, 0);
      var rate = discountRate(totalQuantity, productRoot);
      entries.forEach(function (entry, index) {
        var node = elements.bundleCardTemplate.content.firstElementChild.cloneNode(true);
        node.dataset.hjv2BundleSlotId = entry.id;
        var label = node.querySelector('[data-slot-label]');
        if (label) label.textContent = entry.title || ordinal(index + 1);
        var image = node.querySelector('[data-slot-image]');
        var overlay = node.querySelector('[data-slot-overlay]');
        if (image) {
          image.src = entry.displayUrl || '';
          image.alt = entry.title || ordinal(index + 1);
          image.style.display = entry.overlay ? 'none' : '';
        }
        if (entry.overlay) setOverlayPreview(overlay, entry.overlay.mockup, entry.overlay.artworkUrl);
        else hideOverlayPreview(overlay);
        var edit = node.querySelector('[data-slot-edit]');
        if (edit) {
          edit.dataset.hjv2BundleSlotId = entry.id;
          edit.disabled = !!(entry.slot && (entry.slot.loading || entry.slot.processing));
          edit.setAttribute('aria-disabled', edit.disabled ? 'true' : 'false');
        }
        var remove = node.querySelector('[data-slot-remove]');
        if (remove) {
          remove.dataset.hjv2BundleSlotId = entry.id;
          remove.hidden = entry.isMain;
        }
        appendCardOptions(node.querySelector('.hj-tee-set-card__main-options'), entry);
        var price = entry.variant ? entry.variant.price : 0;
        var discounted = Math.max(0, price - Math.round(price * rate));
        var priceNode = node.querySelector('[data-slot-price]');
        var originalNode = node.querySelector('[data-slot-original-price]');
        if (priceNode) priceNode.textContent = formatMoney(discounted);
        if (originalNode) {
          originalNode.textContent = formatMoney(price);
          originalNode.hidden = rate === 0;
        }
        elements.bundleCards.appendChild(node);
      });
    }

    function invalidateBundleSlot(slot) {
      slot.generation += 1;
      clearLoadingMessageTimer(slot);
      slot.completed = null;
      slot.processing = false;
      slot.displayUrl = slot.product ? slot.product.image : slot.image;
      syncPurchaseSummary();
    }

    function renderBundleFields(slot) {
      elements.dynamicForm.innerHTML = '';
      slot.inputs = {};
      fileInput.accept = slot.template.upload.types.join(',');
      var imageIndex = 0;
      slot.template.slots.forEach(function (field, index) {
        var group = document.createElement('div');
        group.className = 'form-group';
        var id = 'Hjv2BundleField-' + slot.id + '-' + index;
        var label = document.createElement('label');
        label.htmlFor = id;
        label.textContent = field.label + (field.required ? ' *' : '');
        group.appendChild(label);
        var input;
        if (field.type === 'image') {
          imageIndex += 1;
          if (imageIndex === 1) {
            input = fileInput;
            group.hidden = true;
          } else {
            input = document.createElement('input');
            input.type = 'file';
            input.id = id;
            input.accept = slot.template.upload.types.join(',');
            input.className = 'hjv2-extra-file';
            var status = document.createElement('span');
            status.className = 'hjv2-extra-file-status';
            status.textContent = slot.values[field.key] ? 'Image uploaded.' : 'Maximum ' + Math.ceil(slot.template.upload.maxBytes / 1048576) + ' MB.';
            input.addEventListener('change', function () {
              uploadPersonalizationFile(slot, field.key, input.files && input.files[0], status, {
                clearValue: true,
                invalidate: function () { invalidateBundleSlot(slot); }
              });
            });
            group.appendChild(input);
            group.appendChild(status);
          }
        } else {
          input = document.createElement('input');
          input.type = 'text';
          input.id = id;
          input.required = field.required;
          input.value = slot.values[field.key] || '';
          if (field.minLength !== null) input.minLength = field.minLength;
          if (field.maxLength !== null) input.maxLength = field.maxLength;
          input.addEventListener('input', function () {
            slot.values[field.key] = input.value;
            invalidateBundleSlot(slot);
          });
          group.appendChild(input);
        }
        slot.inputs[field.key] = input;
        var error = document.createElement('span');
        error.className = 'hjv2-field-error';
        error.hidden = true;
        group.appendChild(error);
        elements.dynamicForm.appendChild(group);
      });
    }

    async function handleBundlePrimaryFile(slot, file) {
      if (!slot || !file || slot.loading || slot.processing || !slot.template || !isModalOwner(slot)) return;
      clearError();
      var firstImage = slot.template.slots.find(function (field) { return field.type === 'image'; });
      if (!firstImage) return;
      var key = firstImage.key;
      setLocalPhotoPreview(slot, file);
      showUploadStep();
      await uploadPersonalizationFile(slot, key, file, null, {
        clearValue: true,
        primary: true,
        invalidate: function () { invalidateBundleSlot(slot); }
      });
      if (isModalOwner(slot)) showUploadStep();
    }

    async function fetchBundleProduct(handle, fallback) {
      if (bundle.productCache[handle]) return bundle.productCache[handle];
      var response = await fetchWithTimeout('/products/' + encodeURIComponent(handle) + '.js', {
        method: 'GET', headers: { Accept: 'application/json' }
      }, REQUEST_TIMEOUT_MS);
      if (!response.ok) throw new Error('Product unavailable');
      var product = normalizeProduct(await response.json(), fallback);
      if (!product) throw new Error('Invalid product');
      bundle.productCache[handle] = product;
      return product;
    }

    async function resolveBundleFlow(slot) {
      var response = await fetchWithTimeout(API_BASE_URL + '/api/personalization-template?product=' + encodeURIComponent(slot.product.handle), {
        method: 'GET', headers: { Accept: 'application/json' }
      }, TEMPLATE_TIMEOUT_MS);
      if (!response.ok) throw new Error('Template unavailable');
      var template = normalizeTemplate(await response.json());
      if (!template) throw new Error('Invalid template');
      slot.template = template;
      preloadTemplateMockups(template);
    }

    async function createBundleSlot(trigger) {
      var slot = {
        id: bundle.nextId++,
        title: trigger.dataset.title || 'Custom tee',
        image: trigger.dataset.image || '',
        product: null,
        variantId: '',
        quantity: 1,
        template: null,
        values: {},
        inputs: {},
        uploadVersions: {},
        uploadsInFlight: 0,
        generation: 0,
        completed: null,
        processing: false,
        loading: true,
        displayUrl: trigger.dataset.image || '',
        photoPreviewUrl: '',
        localPhotoPreviewUrl: '',
        modalStage: 'upload'
      };
      bundle.slots.push(slot);
      bundle.activeSlot = slot;
      syncPurchaseSummary();
      closeBundlePicker();
      openModal();
      elements.dynamicForm.innerHTML = '';
      showProcessing();
      setStatus('Loading personalization options…', true);
      setMockupStatus('Loading personalization options…', 'loading');
      try {
        slot.product = await fetchBundleProduct(trigger.dataset.handle, {
          handle: trigger.dataset.handle,
          title: slot.title,
          image: slot.image
        });
        if (bundle.slots.indexOf(slot) === -1) return;
        var firstAvailable = slot.product.variants.find(function (variant) { return variant.available; }) || slot.product.variants[0];
        slot.variantId = firstAvailable.id;
        slot.displayUrl = slot.product.image || slot.image;
        await resolveBundleFlow(slot);
        if (bundle.slots.indexOf(slot) === -1) return;
        slot.loading = false;
        var reuseUrl = mainSourceImageUrl();
        if (reuseUrl) {
          slot.photoPreviewUrl = reuseUrl;
          var firstImage = slot.template.slots.find(function (field) { return field.type === 'image'; });
          if (firstImage) slot.values[firstImage.key] = reuseUrl;
        }
        syncPurchaseSummary();
        if (bundle.activeSlot !== slot) clearLoadingMessageTimer(slot);
        if (bundle.activeSlot === slot) {
          renderBundleFields(slot);
          if (!slot.template.slots.some(function (field) { return field.type === 'image'; })) showDetails();
          else showUploadStep();
        }
      } catch (error) {
        slot.loading = false;
        clearLoadingMessageTimer(slot);
        revokeLocalPhotoPreview(slot);
        bundle.slots = bundle.slots.filter(function (item) { return item !== slot; });
        syncPurchaseSummary();
        if (bundle.activeSlot !== slot) return;
        bundle.activeSlot = null;
        elements.dynamicForm.innerHTML = '';
        showDetails();
        elements.confirm.disabled = true;
        showError('Could not load this product. Please close this window and choose another design.');
      }
    }

    function openBundleSlot(slot) {
      if (!slot || slot.loading || slot.processing || !slot.template) {
        setLive(slot && slot.processing ? 'This preview is still being created.' : 'Personalization options are still loading.');
        return;
      }
      bundle.activeSlot = slot;
      renderBundleFields(slot);
      openModal();
      if (!slot.template.slots.some(function (field) { return field.type === 'image'; })) {
        showDetails();
      } else {
        showUploadStep();
      }
    }

    function openMainSlot() {
      if (state.processing) {
        setLive('This preview is still being created.');
        return;
      }
      bundle.activeSlot = null;
      renderFields();
      openModal();
      if (state.completed) showDetails();
      else if (mainSourceImageUrl()) showUploadStep();
      else fileInput.click();
    }

    function openBundlePicker() {
      if (!elements.bundlePicker) return;
      elements.bundlePicker.hidden = false;
      document.documentElement.classList.add('hj-tee-set-picker-open');
    }

    function closeBundlePicker() {
      if (!elements.bundlePicker) return;
      elements.bundlePicker.hidden = true;
      document.documentElement.classList.remove('hj-tee-set-picker-open');
    }

    function removeBundleSlot(slot) {
      slot.generation += 1;
      Object.keys(slot.uploadVersions || {}).forEach(function (key) { slot.uploadVersions[key] += 1; });
      clearLoadingMessageTimer(slot);
      revokeLocalPhotoPreview(slot);
      bundle.slots = bundle.slots.filter(function (item) { return item !== slot; });
      if (bundle.activeSlot === slot) bundle.activeSlot = null;
      syncPurchaseSummary();
    }

    function syncBundleVariantFromCard(input) {
      var slotId = input.dataset.hjv2BundleSlotId;
      if (slotId === 'main') {
        var mainInputs = Array.prototype.slice.call(elements.bundleCards.querySelectorAll('[data-hjv2-bundle-slot-id="main"] [data-hjv2-bundle-option-index]'));
        var values = selectedVariant().options.slice();
        mainInputs.forEach(function (control) { values[parseInt(control.dataset.hjv2BundleOptionIndex, 10)] = control.value; });
        var mainVariant = mainProduct.variants.find(function (variant) {
          return variant.available && values.every(function (value, index) { return variant.options[index] === value; });
        });
        if (mainVariant) elements.variantId.value = String(mainVariant.id);
        syncOptionControls(selectedVariant());
        if (state.completed) applyCompletedMockup();
        else syncPurchaseSummary();
        return;
      }
      var slot = bundleSlotById(slotId);
      if (!slot) return;
      var current = bundleSelectedVariant(slot);
      var selectedValues = current.options.slice();
      var card = input.closest('.hj-tee-set-card');
      card.querySelectorAll('[data-hjv2-bundle-option-index]').forEach(function (control) {
        selectedValues[parseInt(control.dataset.hjv2BundleOptionIndex, 10)] = control.value;
      });
      var variant = slot.product.variants.find(function (item) {
        return item.available && selectedValues.every(function (value, index) { return item.options[index] === value; });
      });
      if (variant) slot.variantId = String(variant.id);
      if (slot.completed) applyBundleCompletedMockup(slot);
      else syncPurchaseSummary();
    }

    function preloadImage(url) {
      return new Promise(function (resolve, reject) {
        var image = new Image();
        var timer = window.setTimeout(function () { reject(new Error('Preview timed out')); }, 20000);
        image.onload = function () { window.clearTimeout(timer); resolve(); };
        image.onerror = function () { window.clearTimeout(timer); reject(new Error('Preview failed')); };
        image.src = url;
      });
    }

    async function completeBundleGeneration(slot, artworkUrl, originalDesignUrl, token) {
      if (token !== slot.generation || bundle.slots.indexOf(slot) === -1) return;
      var completed = createCompletedResult(slot.template, artworkUrl, originalDesignUrl);
      var resolved = bundleCompletedMockup(Object.assign({}, slot, { completed: completed }));
      if (!resolved || !resolved.mockup || !resolved.mockup.overlay) throw new Error('Invalid client overlay template');
      await Promise.all([resolved.url, artworkUrl].map(preloadImage));
      if (token !== slot.generation || bundle.slots.indexOf(slot) === -1) return;
      clearLoadingMessageTimer(slot);
      slot.completed = completed;
      slot.processing = false;
      var safariPosition = null;
      if (isSafari && isModalOwner(slot) && modal.open) {
        setStatus('Your preview is ready.', false);
        resetLoadingVisual(slot);
        safariPosition = await closeSafariModalBeforePageUpdate(slot);
        if (token !== slot.generation || bundle.slots.indexOf(slot) === -1) return;
        bundle.activeSlot = null;
      }
      applyBundleCompletedMockup(slot);
      preserveSafariPagePosition(safariPosition);
      prepareTshirtVariousMockups(completed, slot.template, token, slot);
    }

    async function generateBundleV2(slot, token) {
      await submitGenerationJob({
        owner: slot,
        template: slot.template,
        productHandle: slot.product.handle,
        token: token,
        label: 'bundle generation #' + slot.id,
        isActive: function () { return bundle.activeSlot === slot; },
        onCompleted: function (artworkUrl, sessionId, originalDesignUrl) {
          return completeBundleGeneration(slot, artworkUrl, originalDesignUrl, token);
        }
      });
    }

    async function generateBundleSlot(slot) {
      clearError();
      if (!slot || slot.loading || !slot.template || !slot.product || slot.processing) return;
      if (slot.uploadsInFlight > 0) { showError('Please wait for your image to finish uploading.'); return; }
      if (!fieldsValid(slot, true)) return;
      var variant = bundleSelectedVariant(slot);
      if (!variant || !variant.available) { showError('Please choose an available variant.'); return; }
      invalidateBundleSlot(slot);
      var token = slot.generation;
      slot.processing = true;
      syncPurchaseSummary();
      if (isModalOwner(slot)) showProcessing();
      try {
        await generateBundleV2(slot, token);
        if (token !== slot.generation || bundle.slots.indexOf(slot) === -1) return;
        if (isModalOwner(slot)) {
          setStatus('Your preview is ready.', false);
          resetLoadingVisual(slot);
          bundle.activeSlot = null;
          closeModal();
        }
      } catch (error) {
        if (token !== slot.generation || bundle.slots.indexOf(slot) === -1) return;
        clearLoadingMessageTimer(slot);
        slot.processing = false;
        var errorMessage = error.publicMessage || error.message || 'We could not create your preview. Please try again.';
        syncPurchaseSummary();
        if (!isModalOwner(slot)) return;
        showDetails();
        showError(errorMessage);
        if (elements.confirmText) elements.confirmText.textContent = 'Try Again';
      }
    }

    function handleConfirm() {
      if (bundle.activeSlot) {
        var active = bundle.activeSlot;
        if (active.loading || active.processing || !active.template) return;
        if (active.modalStage === 'upload') {
          if (active.uploadsInFlight > 0) {
            setStatus('Please wait for your image to finish uploading.', true);
            return;
          }
          var image = active.template.slots.find(function (field) { return field.type === 'image'; });
          var hasPhoto = !image || !image.required || !!active.values[image.key];
          if (!hasPhoto) {
            setStatus('Please upload your photo to continue.', true);
            return;
          }
          if (templateHasDetailFields(active.template)) showDetails();
          else generateBundleSlot(active);
          return;
        }
        if (active.modalStage === 'details') generateBundleSlot(active);
        return;
      }
      if (state.modalStage === 'upload') {
        if (state.uploadsInFlight > 0) {
          setStatus('Please wait for your image to finish uploading.', true);
          return;
        }
        var primaryImage = state.template.slots.find(function (slot) { return slot.type === 'image'; });
        if (primaryImage && primaryImage.required && !state.values[primaryImage.key]) {
          setStatus('Please upload your photo to continue.', true);
          return;
        }
        if (templateHasDetailFields(state.template)) showDetails();
        else generate();
        return;
      }
      if (state.modalStage === 'details') generate();
    }

    function bindActiveUi() {
      var firstImageSlot = state.template.slots.find(function (slot) { return slot.type === 'image'; });
      fileInput.accept = state.template.upload.types.join(',');
      fileInput.multiple = false;

      scope.addEventListener('click', function (event) {
        var action = event.target.closest('[data-action]');
        if (action && action.dataset.action === 'open-tee-bundle-picker') {
          event.preventDefault();
          openBundlePicker();
          return;
        }
        if (action && action.dataset.action === 'close-tee-bundle-picker') {
          event.preventDefault();
          closeBundlePicker();
          return;
        }
        if (action && action.dataset.action === 'choose-tee-bundle-product') {
          event.preventDefault();
          createBundleSlot(action);
          return;
        }

        var removeSlotButton = event.target.closest('[data-slot-remove][data-hjv2-bundle-slot-id]');
        if (removeSlotButton) {
          event.preventDefault();
          var removeSlot = bundleSlotById(removeSlotButton.dataset.hjv2BundleSlotId);
          if (removeSlot) removeBundleSlot(removeSlot);
          return;
        }

        var uploadTrigger = event.target.closest('.upload-trigger');
        if (uploadTrigger) {
          event.preventDefault();
          if (uploadTrigger.dataset.hjv2BundleSlotId === 'main') {
            openMainSlot();
            return;
          }
          if (uploadTrigger.dataset.hjv2BundleSlotId) {
            var editSlot = bundleSlotById(uploadTrigger.dataset.hjv2BundleSlotId);
            if (editSlot) openBundleSlot(editSlot);
            return;
          }
          bundle.activeSlot = null;
          if (state.completed) {
            renderFields();
            openModal();
            showDetails();
          } else if (firstImageSlot && state.values[firstImageSlot.key]) {
            openModal();
            showUploadStep();
          } else if (firstImageSlot) {
            fileInput.click();
          } else {
            openModal();
            showDetails();
          }
          return;
        }

        var productTypeButton = event.target.closest('[data-hjv2-product-type-value]');
        if (productTypeButton && productTypeButton.closest('.hj-tee-product')) {
          event.preventDefault();
          if (productTypeButton.disabled) return;
          var productTypeGroup = productTypeButton.closest('[data-hjv2-product-type-group]');
          var productTypeInput = productTypeGroup && productTypeGroup.querySelector(
            '[data-hjv2-option-index],[data-hjv2-bundle-option-index]'
          );
          if (!productTypeInput) return;
          productTypeInput.value = productTypeButton.dataset.hjv2ProductTypeValue || '';
          if (productTypeInput.hasAttribute('data-hjv2-bundle-option-index')) {
            syncBundleVariantFromCard(productTypeInput);
          } else {
            syncVariantFromOptions();
            if (state.completed) applyCompletedMockup();
            else syncPurchaseSummary();
          }
          return;
        }

        var option = event.target.closest('.hj-size-combo .combo-option');
        if (option && option.closest('.hj-tee-product')) {
          var combo = option.closest('.combo');
          var input = combo.querySelector('.combo-input');
          var label = combo.querySelector('.combo-label');
          combo.querySelectorAll('.combo-option').forEach(function (item) { item.classList.toggle('active', item === option); });
          if (input) input.value = option.dataset.value || '';
          if (label) label.textContent = option.dataset.value || '';
          combo.classList.remove('open');
          if (input && input.hasAttribute('data-hjv2-bundle-option-index')) {
            syncBundleVariantFromCard(input);
          } else if (input && input.hasAttribute('data-hjv2-option-index')) {
            syncVariantFromOptions();
            if (state.completed) applyCompletedMockup();
            else syncPurchaseSummary();
          }
          return;
        }

        var trigger = event.target.closest('.hj-size-combo .combo-trigger');
        if (trigger && trigger.closest('.hj-tee-product')) {
          event.preventDefault();
          trigger.closest('.combo').classList.toggle('open');
          return;
        }

        var quantityButton = event.target.closest('[data-qty-dec],[data-qty-inc]');
        if (quantityButton && elements.quantity) {
          event.preventDefault();
          var quantity = Math.max(1, parseInt(elements.quantity.value || '1', 10) || 1);
          elements.quantity.value = String(quantityButton.hasAttribute('data-qty-dec') ? Math.max(1, quantity - 1) : quantity + 1);
          syncPurchaseSummary();
          return;
        }

        var slotQuantityButton = event.target.closest('[data-hjv2-slot-qty-dec],[data-hjv2-slot-qty-inc]');
        if (slotQuantityButton) {
          event.preventDefault();
          var slotId = slotQuantityButton.dataset.hjv2BundleSlotId;
          var quantityInput = slotQuantityButton.parentElement.querySelector('[data-hjv2-slot-qty]');
          var quantityValue = Math.max(1, parseInt(quantityInput.value || '1', 10) || 1);
          quantityValue = slotQuantityButton.hasAttribute('data-hjv2-slot-qty-dec') ? Math.max(1, quantityValue - 1) : quantityValue + 1;
          quantityInput.value = String(quantityValue);
          if (slotId === 'main') {
            elements.quantity.value = String(quantityValue);
          } else {
            var quantitySlot = bundleSlotById(slotId);
            if (quantitySlot) quantitySlot.quantity = quantityValue;
          }
          syncPurchaseSummary();
          return;
        }

        var thumb = event.target.closest('.hj-tee-gallery__thumb');
        if (thumb && elements.gallery && thumb.dataset.imageSrc) {
          productRoot.querySelectorAll('.hj-tee-gallery__thumb').forEach(function (item) { item.classList.toggle('is-active', item === thumb); });
          elements.gallery.src = thumb.dataset.imageSrc;
        }
      });

      fileInput.addEventListener('change', function () {
        var file = fileInput.files && fileInput.files[0];
        if (file) {
          if (bundle.activeSlot) handleBundlePrimaryFile(bundle.activeSlot, file);
          else handlePrimaryFile(file);
        }
        fileInput.value = '';
      });
      elements.confirm.addEventListener('click', handleConfirm);
      if (elements.close) elements.close.addEventListener('click', closeModal);
      if (elements.reuseUpload) elements.reuseUpload.addEventListener('click', function () { fileInput.click(); });
      modal.addEventListener('click', function (event) { if (event.target === modal) closeModal(); });
      modal.addEventListener('cancel', releaseModalFocus);
      modal.addEventListener('close', releaseModalScroll);
      if (elements.quantity) elements.quantity.addEventListener('change', function () {
        elements.quantity.value = String(Math.max(1, parseInt(elements.quantity.value || '1', 10) || 1));
        syncPurchaseSummary();
      });
      scope.addEventListener('change', function (event) {
        var slotQuantity = event.target.closest('[data-hjv2-slot-qty]');
        if (!slotQuantity) return;
        var value = Math.max(1, parseInt(slotQuantity.value || '1', 10) || 1);
        slotQuantity.value = String(value);
        var slotId = slotQuantity.dataset.hjv2BundleSlotId;
        if (slotId === 'main') elements.quantity.value = String(value);
        else {
          var changedSlot = bundleSlotById(slotId);
          if (changedSlot) changedSlot.quantity = value;
        }
        syncPurchaseSummary();
      });
      elements.variantId.addEventListener('change', function () {
        syncOptionControls(selectedVariant());
        if (state.completed) applyCompletedMockup();
        else syncPurchaseSummary();
      });
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (state.addingToCart) return;
        if (!state.completed || !fieldsValid(state, true) || !bundleReadyForCart()) {
          bundle.activeSlot = null;
          renderFields();
          openModal();
          showDetails();
          showError('Generate a valid preview for every design before adding these items to cart.');
          return;
        }
        var items = allPurchaseEntries().map(function (entry) {
          return {
            id: Number(entry.variant.id),
            quantity: entry.quantity,
            properties: entry.properties
          };
        }).filter(function (item) {
          return item.id && item.quantity > 0 && isObject(item.properties);
        });
        if (!items.length) return;
        state.addingToCart = true;
        elements.atc.disabled = true;
        try {
          var response = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
          var data = await response.json().catch(function () { return {}; });
          if (!response.ok) throw new Error(data.description || 'Could not add these items to cart.');
        } catch (error) {
          state.addingToCart = false;
          syncPurchaseSummary();
          bundle.activeSlot = null;
          renderFields();
          openModal();
          showDetails();
          showError(error.message || 'Could not add these items to cart. Please try again.');
          return;
        }

        var cartUrl = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        if (!window.CartDrawerController) {
          window.location.href = cartUrl;
          return;
        }
        try {
          window.CartDrawerController.open();
          await Promise.resolve(window.CartDrawerController.update());
          state.addingToCart = false;
          syncPurchaseSummary();
          setLive('Added to cart.');
        } catch (drawerError) {
          console.error('[HavJoy] Cart drawer failed after items were added', drawerError);
          window.location.href = cartUrl;
        }
      }, true);
    }

    async function bootstrap() {
      scope.dataset.hjV2State = 'checking';
      try {
        var response = await fetchWithTimeout(
          API_BASE_URL + '/api/personalization-template?product=' + encodeURIComponent(productData.product_handle),
          { method: 'GET', headers: { Accept: 'application/json' } },
          TEMPLATE_TIMEOUT_MS
        );
        if (!response.ok) throw new Error('Template unavailable');
        var template = normalizeTemplate(await response.json());
        if (!template) throw new Error('Invalid template');
        state.template = template;
        var restoredUploadUrl = readLatestUploadedUrl();
        var primaryImageSlot = template.slots.find(function (slot) { return slot.type === 'image'; });
        if (restoredUploadUrl && primaryImageSlot && !state.values[primaryImageSlot.key]) {
          state.values[primaryImageSlot.key] = restoredUploadUrl;
          state.photoPreviewUrl = restoredUploadUrl;
          state.previewUrl = restoredUploadUrl;
        }
        preloadTemplateMockups(template);
        renderFields();
        bindActiveUi();
        elements.optionInputs.forEach(function (input) {
          if (input.getAttribute('name') === 'properties[Size Tee 1]') input.removeAttribute('name');
        });
        scope.dataset.hjV2State = 'active';
        elements.atc.disabled = true;
        syncPurchaseSummary();
      } catch (error) {
        scope.dataset.hjV2State = 'active';
        elements.atc.disabled = true;
        scope.addEventListener('click', function (event) {
          var trigger = event.target.closest('.upload-trigger');
          if (!trigger) return;
          event.preventDefault();
          elements.dynamicForm.innerHTML = '';
          openModal();
          showDetails();
          elements.confirm.disabled = true;
          showError('Personalization options are unavailable for this product. Please try again later.');
        });
      }
    }

    bootstrap();
  }

  document.querySelectorAll('[data-hjv2-root]').forEach(init);
})();
